const locale = {
  'Invite generated': 'Invitación generada',
  'This token will be shown only once': 'Este token se mostrará una sola vez',
  'Copy it now and send it through a secure channel. It is single-use and we store only its hash — if lost, revoke it and generate another.': 'Cópialo ahora y envíalo por un canal seguro. Es de un solo uso y guardamos solo su hash — si se pierde, revócalo y genera otro.',
  'Copy token': 'Copiar token',
  'Copied': 'Copiado',
  'Expires in': 'Expira en',
  'Expired': 'Expirado',
  'This token expired. Generate another invite to connect this partner.': 'Este token expiró. Genera otra invitación para conectar a este socio.',
  'Contract': 'Contrato',
  'Bidirectional — both apps display': 'Bidireccional — ambas apps muestran',
  'One-way — only their app displays': 'Unilateral — solo su app muestra',
  'Use': 'Uso',
  'Single use · stored only as a hash': 'Un solo uso · guardado solo como hash',
  'inherits new ones': 'hereda nuevas',
  'Download QR art': 'Descargar arte del QR',
  'Token copied.': 'Token copiado.',
  'Did you copy the token? It cannot be recovered.': '¿Copiaste el token? No podrá ser recuperado.',
  'Close': 'Cerrar',
  'I copied it, close': 'Lo copié, cerrar',
  'Invited tenant': 'Tenant invitado',
  'Select a tenant': 'Selecciona un tenant',
  'Contact e-mail': 'Correo de contacto',
  'Accounts in the contract': 'Cuentas que entran en el contrato',
  'sharing always covers every station of the account': 'el compartir siempre cubre todas las estaciones de la cuenta',
  'All accounts': 'Todas las cuentas',
  'All except...': 'Todas, excepto…',
  'Select accounts': 'Seleccionar cuentas',
  'All accounts included — nothing to filter': 'Todas las cuentas incluidas — nada que filtrar',
  'Search sub-account by name': 'Buscar subcuenta por nombre',
  'No sub-account with that name': 'Ninguna subcuenta con ese nombre',
  'select all': 'marcar todas',
  'clear exclusions': 'limpiar excepciones',
  'Parent account always included': 'Matriz siempre incluida',
  'sub-accounts included automatically': 'subcuentas incluidas automáticamente',
  'out of the contract': 'fuera del contrato',
  'sub-accounts marked': 'subcuentas marcadas',
  'accounts': 'cuentas',
  'Automatically include new sub-accounts': 'Incluir automáticamente nuevas subcuentas',
  'Visibility contract type': 'Tipo de contrato de visualización',
  'This tenant has an app configured — it can receive stations, so the bidirectional contract is available.': 'Este tenant tiene app configurada — puede recibir estaciones, así que el contrato bidireccional está disponible.',
  'This tenant has no app configured: it does not receive stations. Only the one-way contract is possible.': 'Este tenant no tiene app configurada: no recibe estaciones. Solo el contrato unilateral es posible.',
  'Token validity': 'Validez del token',
  '* Required fields. The partner only sees your network after entering the token.': '* Campos obligatorios. El socio solo verá tu red después de ingresar el token.',
  'Generate invite': 'Generar invitación',
  'Could not generate the invite. Try again.': 'No se pudo generar la invitación. Intenta de nuevo.',
  'Accounts of my hierarchy in this contract': 'Cuentas de mi jerarquía en este contrato',
  'Pending changes: {0} entering, {1} leaving': 'Cambios pendientes: {0} entrando, {1} saliendo',
  'Apply the new contract scope?': '¿Aplicar el nuevo alcance del contrato?',
  'These accounts, and any sub-accounts below them, stop being displayed to the partner right away: {0}. The contract stays active.': 'Estas cuentas, y las subcuentas debajo de ellas, dejan de mostrarse al socio de inmediato: {0}. El contrato sigue activo.',
  'The marked accounts start being displayed to the partner. The contract stays active.': 'Las cuentas marcadas pasan a mostrarse al socio. El contrato sigue activo.',
  'Apply': 'Aplicar',
  'Apply scope': 'Aplicar alcance',
  'Applying...': 'Aplicando...',
  'Undo': 'Deshacer',
  'will be added': 'entra',
  'will be removed': 'sale',
  'The parent account cannot leave the contract.': 'La cuenta matriz no puede salir del contrato.',
  'Contract scope updated.': 'Alcance del contrato actualizado.',
  'Could not change the scope now. Nothing was changed.': 'No fue posible cambiar el alcance ahora. Nada fue cambiado.',
  'parent account': 'matriz',
  'sub-account': 'subcuenta',
  'stations': 'estaciones',
  'Loading...': 'Cargando...',
  'Could not load the accounts of this contract.': 'No se pudieron cargar las cuentas de este contrato.',
  'New sub-accounts join this contract automatically — no new invite.': 'Las nuevas subcuentas entran automáticamente — sin nueva invitación.',
  'New sub-accounts do NOT join automatically: each inclusion is an explicit action.': 'Las nuevas subcuentas NO entran automáticamente: cada inclusión es una acción explícita.',
  'app configured': 'app configurada',
  'no app': 'sin app',
  'Bidirectional': 'Bidireccional',
  'One-way': 'Unilateral',
  'Ativo': 'Activo',
  'Convite pendente': 'Invitación pendiente',
  'Suspenso': 'Suspendido',
  'Revogado': 'Revocado',
  'Suspend': 'Suspender',
  'Reactivate': 'Reactivar',
  'Revoke': 'Revocar',
  'You have no connected partners yet': 'Aún no tienes socios conectados',
  'I have an invite token': 'Tengo un token de invitación',
  'Show or hide these stations in my app': 'Mostrar u ocultar estas estaciones en mi app',
  'Revoking ends this contract. Reconnecting requires a new invite. Continue?': 'Revocar termina este contrato. Reconectar exige una nueva invitación. ¿Continuar?',
  'A contract is only bidirectional when both tenants have an app configured — without an app the partner can share stations but receives none. Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'El contrato solo es bidireccional cuando ambos tenants tienen app configurada — sin app, el socio puede compartir estaciones pero no recibe ninguna. Activar o desactivar la recepción no cambia el contrato: solo oculta las estaciones del socio en tu app.',
  'Interoperability': 'Interoperabilidad',
  'Connections': 'Conexiones',
  'Connection map': 'Mapa de conexiones',
  'History': 'Historial',
  'Invite partner': 'Invitar socio',
  'Enter token': 'Ingresar token',
  'Review invite': 'Revisar invitación',
  'Each accepted invite creates a station visibility contract — bidirectional or one-way.': 'Cada invitación aceptada crea un contrato de visualización de estaciones — bidireccional o unilateral.',
  'wants your app to display their stations': 'quiere que tu app muestre sus estaciones',
  'invite(s) sent awaiting acceptance': 'invitación(es) enviada(s) esperando aceptación',
  'Could not load interoperability data. Try again.': 'No se pudieron cargar los datos de interoperabilidad. Intenta de nuevo.',
  'Accept invite': 'Aceptar invitación',
  'Paste the token your partner sent you': 'Pega el token que envió el socio',
  'Paste the token sent by': 'Pega el token enviado por',
  'Validate': 'Validar',
  'Single-use and time-limited. The token never appears in the URL — up to 5 attempts.': 'Uso único y con plazo. El token nunca aparece en la URL — máximo de 5 intentos.',
  'Valid token': 'Token válido',
  'Bidirectional contract': 'Contrato bidireccional',
  'One-way contract': 'Contrato unilateral',
  'both sides display each other stations': 'los dos lados muestran las estaciones del otro',
  'only your app starts displaying stations': 'solo tu app pasa a mostrar estaciones',
  'Your app starts displaying': 'Tu app pasa a mostrar',
  'from': 'de',
  'account(s)': 'cuenta(s)',
  'starts displaying': 'pasa a mostrar',
  'of your stations': 'estaciones tuyas',
  'I authorize the sharing described above': 'Autorizo el compartimiento descrito arriba',
  'Connect': 'Conectar',
  'Connected with': 'Conectado con',
  'The token was invalidated and cannot be used again. The contract is now active and the stations are already in your combined network.': 'El token fue invalidado y no puede usarse otra vez. El contrato está activo y las estaciones ya entraron en tu red combinada.',
  'expires in': 'expira en',
  'no longer valid': 'ya no es válido',
  'expired': 'expirado',
  'This token expired on': 'Este token expiró el',
  'Ask your partner for a new one.': 'Pide otro al socio.',
  'This token has expired.': 'Este token expiró.',
  'This token was already used on': 'Este token ya fue utilizado el',
  'This token was already used.': 'Este token ya fue utilizado.',
  'This invite was cancelled by whoever sent it.': 'Esta invitación fue cancelada por quien la envió.',
  'Too many attempts. Wait a few minutes before trying again.': 'Demasiados intentos. Espera unos minutos antes de intentar de nuevo.',
  'This is an account token, not an invite token.': 'Este es el token de una cuenta, no de una invitación.',
  'The invite token is the one your partner generates for you.': 'El token de la invitación es el que genera tu socio para ti.',
  'This is an invite token, not an account token.': 'Este es el token de una invitación, no de una cuenta.',
  'Ask your partner for the token of their account.': 'Pídele a tu socio el token de su cuenta.',
  'Account token generated': 'Token de la cuenta generado',
  'Account token renewed': 'Token de la cuenta renovado',
  'Invites': 'Invitaciones',
  'Direction': 'Dirección',
  'Sent': 'Enviada',
  'Received': 'Recibida',
  'Deadline': 'Plazo',
  'Pending': 'Pendiente',
  'Accepted': 'Aceptada',
  'accepted': 'aceptada',
  'accepted on': 'aceptada el',
  'expired on': 'venció el',
  'Revoked': 'Revocada',
  'revoked': 'revocada',
  'Revoke this invite?': '¿Revocar esta invitación?',
  'The token stops working immediately and': 'El token deja de valer de inmediato y',
  'will no longer be able to accept it. To connect later you have to send a new invite.': 'ya no podrá aceptarla. Para conectar después hay que enviar una nueva invitación.',
  'the partner': 'el socio',
  'Invite revoked.': 'Invitación revocada.',
  'Could not revoke the invite. Nothing was changed.': 'No se pudo revocar la invitación. No se cambió nada.',
  'Could not load the invites.': 'No se pudieron cargar las invitaciones.',
  'No invites yet. Invite a partner to get started.': 'Aún no hay invitaciones. Invita a un socio para empezar.',
  'Only whoever sent an invite can revoke it.': 'Solo quien envió la invitación puede revocarla.',
  'invites': 'invitaciones',
  'Integrations': 'Integraciones',
  'Integrator': 'Integrador',
  'Scopes': 'Alcances',
  'Last use': 'Último uso',
  'never used': 'nunca usado',
  'Active': 'Activo',
  'Validity': 'Vigencia',
  'New token': 'Nuevo token',
  'New integration token': 'Nuevo token de integración',
  'Create token': 'Crear token',
  'Creating...': 'Creando...',
  'Integration token created': 'Token de integración creado',
  'Read data': 'Consultar datos',
  'Operate charging': 'Operar recarga',
  'Manage contracts': 'Gestionar contratos',
  'sensitive': 'sensible',
  'Query connections, cross charges, history and contract stations.': 'Consultar conexiones, recargas cross, historial y estaciones del contrato.',
  'Start and stop charging on the stations this contract reaches. This is the only scope with a physical effect.': 'Iniciar y detener recarga en las estaciones que este contrato alcanza. Es el único alcance con efecto físico.',
  'Generate invites, accept, revoke and change scope. A compromised integrator can open your network to a third party.': 'Generar invitaciones, aceptar, revocar y cambiar alcance. Un integrador comprometido puede abrir tu red a un tercero.',
  'Who is this integrator?': '¿Quién es este integrador?',
  'Billing ACME, BI dashboard, partner app...': 'Facturación ACME, panel de BI, app del socio...',
  'This name is how you will recognize the token later, to revoke it.': 'Este nombre es cómo reconocerás el token después, para revocarlo.',
  'What can this token do?': '¿Qué puede hacer este token?',
  'Nothing is granted by default: mark only what the integrator needs.': 'Nada se concede por defecto: marca solo lo que el integrador necesita.',
  'Leave empty for a token that does not expire.': 'Déjalo vacío para un token que no expira.',
  'The token is shown once, right after creation.': 'El token se muestra una vez, justo después de crearlo.',
  'This token will be shown only once.': 'Este token se mostrará solo una vez.',
  'Send it to the integrator through a secure channel. We store only a hash — if it is lost, revoke it and create another.': 'Envíalo al integrador por un canal seguro. Guardamos solo el hash — si se pierde, revócalo y crea otro.',
  'Revoke this token?': '¿Revocar este token?',
  'The integration of': 'La integración de',
  'stops working immediately. To restore it you have to create another token and configure it on their side.': 'deja de funcionar de inmediato. Para restaurarla hay que crear otro token y configurarlo de su lado.',
  'Token revoked.': 'Token revocado.',
  'Delete': 'Eliminar',
  'Delete this revoked token?': '¿Eliminar este token revocado?',
  'Token deleted.': 'Token eliminado.',
  'Could not delete the token. Nothing was changed.': 'No se pudo eliminar el token. No se cambió nada.',
  'The token': 'El token',
  'is removed for good. This cannot be undone; the audit trail keeps the record.': 'se elimina definitivamente. Esto no se puede deshacer; la traza de auditoría conserva el registro.',
  'Delete removes this revoked token for good — the audit trail keeps the record.': 'Eliminar quita este token revocado definitivamente — la traza de auditoría conserva el registro.',
  'Delete this revoked connection?': '¿Eliminar esta conexión revocada?',
  'Deleting removes the contract for good. This cannot be undone; the audit trail keeps the record.': 'Eliminar quita el contrato definitivamente. Esto no se puede deshacer; la traza de auditoría conserva el registro.',
  'Connection deleted.': 'Conexión eliminada.',
  '180 days': '180 días',
  '1 year': '1 año',
  'Enable all': 'Habilitar todos',
  'Discard': 'Descartar',
  'Enable': 'Habilitar',
  'Enable eligibility for these accounts?': '¿Habilitar la elegibilidad de estas cuentas?',
  'Enabling an account shares its stations and charges with the cross network. Turn on only what should be visible to partners.': 'Habilitar una cuenta comparte sus estaciones y recargas con la red cross. Active solo lo que deba ser visible para los socios.',
  'No accounts to show.': 'No hay cuentas para mostrar.',
  'Not shared': 'No compartido',
  'This shares their data with the cross network:': 'Esto comparte sus datos con la red cross:',
  'to disable': 'a deshabilitar',
  'to enable': 'a habilitar',
  'will be turned off.': 'se desactivarán.',
  'Eligibility enabled': 'Elegibilidad habilitada',
  'Eligibility disabled': 'Elegibilidad deshabilitada',
  'Children': 'Hijos',
  'Clear all': 'Limpiar todos',
  'Search account by name': 'Buscar cuenta por nombre',
  'No account matches this search.': 'Ninguna cuenta coincide con esta búsqueda.',
  'Applies to every account on this level, including the other pages.': 'Se aplica a todas las cuentas de este nivel, incluidas las de las otras páginas.',
  'not shown (other company)': 'no se muestra (otra empresa)',
  'not recorded': 'no registrado',
  'Could not load the accounts.': 'No se pudieron cargar las cuentas.',
  'Could not update eligibility. Nothing was changed.': 'No se pudo actualizar la elegibilidad. No se cambió nada.',
  'Eligibility': 'Elegibilidad',
  'Eligibility updated.': 'Elegibilidad actualizada.',
  'Enable which accounts can take part in interoperability. Enabling replicates that account stations and charges to the cross network — turn on only what should be shared.': 'Habilite qué cuentas participan de la interoperabilidad. Habilitar replica las estaciones y recargas de esa cuenta a la red cross — active solo lo que se debe compartir.',
  'Grandchildren': 'Nietos',
  'Interoperability eligibility': 'Elegibilidad de interoperabilidad',
  'Level': 'Nivel',
  'No changes to save.': 'No hay cambios para guardar.',
  'No pending changes.': 'No hay cambios pendientes.',
  'Save changes': 'Guardar cambios',
  'Saving…': 'Guardando…',
  'This account': 'Esta cuenta',
  'pending changes': 'cambios pendientes',
  'Delete removes this revoked invite for good — the audit trail keeps the record.': 'Eliminar quita esta invitación revocada definitivamente — la traza de auditoría conserva el registro.',
  'Delete this revoked invite?': '¿Eliminar esta invitación revocada?',
  'The invite is removed for good. This cannot be undone; the audit trail keeps the record.': 'La invitación se elimina definitivamente. Esto no se puede deshacer; la traza de auditoría conserva el registro.',
  'Invite deleted.': 'Invitación eliminada.',
  'Could not delete the invite. Nothing was changed.': 'No se pudo eliminar la invitación. No se cambió nada.',
  '(defaults to the current tenant)': '(por defecto: el tenant actual)',
  '(empty response)': '(respuesta vacía)',
  'API documentation sections': 'Secciones de la documentación de la API',
  'Body': 'Cuerpo',
  'Documentation': 'Documentación',
  'Filter by method, path or description': 'Filtrar por método, ruta o descripción',
  'Filter endpoints': 'Filtrar endpoints',
  'Guide': 'Guía',
  'Hide Try it': 'Ocultar Probar',
  'How your integrators authenticate and what the API offers. The Postman collection carries the same endpoints.': 'Cómo se autentican tus integradores y qué ofrece la API. La colección de Postman trae los mismos endpoints.',
  'In': 'En',
  'Integration token (Bearer) — not stored': 'Token de integración (Bearer) — no se guarda',
  'Internal API': 'API interna',
  'Internal tenant-cross endpoints, generated from the backend. They authenticate by tenant identity or session, not by the integration token.': 'Endpoints internos de tenant-cross, generados desde el backend. Se autentican por identidad de tenant o sesión, no por el token de integración.',
  'No endpoint matches this search.': 'Ningún endpoint coincide con esta búsqueda.',
  'Parameters': 'Parámetros',
  'Partner API': 'API de socio',
  'Request body': 'Cuerpo de la solicitud',
  'Send': 'Enviar',
  'Sending…': 'Enviando…',
  'The integration endpoints, authenticated by the integration token.': 'Los endpoints de integración, autenticados por el token de integración.',
  'Tokens': 'Tokens',
  'Try it': 'Probar',
  'current tenant': 'tenant actual',
  'endpoints': 'endpoints',
  'path': 'ruta',
  'query': 'query',
  'Could not revoke the token. Nothing was changed.': 'No se pudo revocar el token. No se cambió nada.',
  'Could not create the token.': 'No se pudo crear el token.',
  'Could not create the token now. Try again in a moment.': 'No se pudo crear el token ahora. Inténtalo de nuevo en un momento.',
  'Could not load the integration tokens.': 'No se pudieron cargar los tokens de integración.',
  'No integration tokens yet. Create one to give an integrator access.': 'Aún no hay tokens de integración. Crea uno para dar acceso a un integrador.',
  'Tokens your integrators use to operate in your name. Each one carries only the scopes you grant, is shown once at creation, and can be revoked at any time.': 'Tokens que tus integradores usan para operar en tu nombre. Cada uno lleva solo los alcances que concedes, se muestra una vez al crearlo y puede revocarse en cualquier momento.',
  'A token is never shown again after creation — if one is lost, revoke it and create another.': 'Un token nunca se vuelve a mostrar después de crearlo — si se pierde alguno, revócalo y crea otro.',
  'Token': 'Token',
  'not identified': 'no identificado',
  'Renew this token?': '¿Renovar este token?',
  'The current secret stops working immediately and': 'El secreto actual deja de funcionar de inmediato y',
  'will need the new one. Name and scopes stay the same.': 'necesitará el nuevo. Nombre y alcances siguen iguales.',
  'Token renewed.': 'Token renovado.',
  'Could not renew the token. Nothing was changed.': 'No se pudo renovar el token. No se cambió nada.',
  'Extend validity': 'Extender vigencia',
  'Extend this token?': '¿Extender este token?',
  'The same secret goes back to working, with no expiry date.': 'El mismo secreto vuelve a valer, sin fecha de vencimiento.',
  'It was never compromised — it only aged out.': 'Nunca fue comprometido — solo venció.',
  'Validity extended.': 'Vigencia extendida.',
  'Could not extend the validity. Nothing was changed.': 'No se pudo extender la vigencia. No se cambió nada.',
  'Recreate': 'Recrear',
  'Create a new token like this one?': '¿Crear un token nuevo como este?',
  'A new token is created with the same name and scopes.': 'Se crea un token nuevo con el mismo nombre y alcances.',
  'The revoked one stays revoked in the list — the old secret never comes back.': 'El revocado sigue revocado en la lista — el secreto antiguo no vuelve.',
  'Token recreated.': 'Token recreado.',
  'Could not recreate the token. Nothing was changed.': 'No se pudo recrear el token. No se cambió nada.',
  'Representative e-mail': 'Correo del representante',
  'optional': 'opcional',
  'Who to contact when the integration breaks. Recorded in the module history.': 'A quién contactar cuando la integración falle. Queda registrado en el historial del módulo.',
  'The token is never sent by e-mail.': 'El token nunca se envía por correo.',
  'Search integrator, e-mail or token': 'Buscar integrador, correo o token',
  'All states': 'Todos los estados',
  'Any scope': 'Cualquier alcance',
  'tokens': 'tokens',
  'of': 'de',
  'No token matches these filters.': 'Ningún token corresponde a estos filtros.',
  'Actions': 'Acciones',
  'Granted': 'Concedidos',
  'Created by': 'Creado por',
  'Last renewal': 'Última renovación',
  'Revoked on': 'Revocado el',
  'The full value is never shown again — only these last characters identify it.': 'El valor completo no se muestra de nuevo — solo estos últimos caracteres lo identifican.',
  'Creates a new token with the same name and scopes. This one stays revoked, and its secret never comes back.': 'Crea un token nuevo con el mismo nombre y alcances. Este sigue revocado, y su secreto no vuelve.',
  'Expired, not compromised: extending brings the same secret back, so the integrator does not have to change anything.': 'Vencido, no comprometido: extender trae el mismo secreto de vuelta, así el integrador no cambia nada.',
  'Renewing swaps the secret and keeps name and scopes — the integrator has to be given the new value. Revoking ends this access for good.': 'Renovar cambia el secreto y mantiene nombre y alcances — el integrador necesita el nuevo valor. Revocar termina este acceso definitivamente.',
  'API': 'API',
  'Download Postman collection': 'Descargar colección de Postman',
  'How to integrate': 'Cómo integrar',
  'This API exposes what this account shares through interoperability contracts. An integrator authenticates with a token you create here, and sees only what the token scopes allow.': 'Esta API expone lo que esta cuenta comparte por los contratos de interoperabilidad. El integrador se autentica con un token creado aquí, y ve solo lo que los alcances permiten.',
  'Create a token with the scopes the integrator needs': 'Crea un token con los alcances que el integrador necesita',
  'Use "New token" above. Nothing is granted by default — mark only what they need. The value appears once, right after creation, and is never shown again.': 'Usa "Nuevo token" arriba. Nada se concede por defecto — marca solo lo que necesita. El valor aparece una vez, justo al crearlo, y nunca más.',
  'Send the token on every request': 'Envía el token en cada solicitud',
  'The token goes in the': 'El token va en el encabezado',
  'header, never in the URL — a URL ends up in browser history and proxy logs.': ', nunca en la URL — la URL entra en el historial del navegador y en el log del proxy.',
  'The base address of this environment is': 'La dirección base de este entorno es',
  'Note there is no tenant in the path: the token itself says which account it is.': 'Nota que no hay tenant en la ruta: el propio token dice de qué cuenta se trata.',
  'Handle the refusals': 'Maneja los rechazos',
  'means the token is missing, revoked or expired.': 'significa token ausente, revocado o vencido.',
  'means the token is valid but lacks a scope this endpoint requires — ask for a token with that scope instead of retrying.': 'significa token válido sin un alcance que el endpoint exige — pide un token con ese alcance en vez de reintentar.',
  'means something in the request is wrong.': 'significa algo incorrecto en la solicitud.',
  'Rotate when needed': 'Rota cuando sea necesario',
  'A lost token cannot be recovered — open its details and use Renew, which keeps the name and scopes and swaps the secret. Revoking ends the access for good.': 'Un token perdido no se recupera — abre el detalle y usa Renovar, que mantiene nombre y alcances y cambia el secreto. Revocar termina el acceso definitivamente.',
  'What each scope unlocks. They are independent: one does not imply another.': 'Lo que cada alcance habilita. Son independientes: uno no implica el otro.',
  'Endpoints': 'Endpoints',
  'Everything the integration API offers today.': 'Todo lo que la API de integración ofrece hoy.',
  'The same list is in the Postman collection you can download above.': 'La misma lista está en la colección de Postman que descargas arriba.',
  'Parameter': 'Parámetro',
  'Description': 'Descripción',
  'Example': 'Ejemplo',
  'Response': 'Respuesta',
  'Search partner by name or alias': 'Buscar socio por nombre o alias',
  'All statuses': 'Todos los estados',
  'Pending invite': 'Invitación pendiente',
  'Suspended': 'Suspendido',
  'Any contract': 'Cualquier contrato',
  'Only the ones I receive from': 'Solo los que recibo',
  'connections': 'conexiones',
  'No connection matches these filters.': 'Ninguna conexión corresponde a estos filtros.',
  'Both directions': 'Los dos sentidos',
  'No invite matches these filters.': 'Ninguna invitación corresponde a estos filtros.',
  'Both apps display the other stations': 'Los dos apps muestran las estaciones del otro',
  'Only your app displays the partner stations': 'Solo tu app muestra las estaciones del socio',
  'Only the partner app displays your stations': 'Solo la app del socio muestra tus estaciones',
  'Any problem': 'Cualquier problema',
  'Available stations': 'Estaciones disponibles',
  'Connectors': 'Conectores',
  'Coordinates': 'Coordenadas',
  'Correct': 'Correcto',
  'Could not load the stations.': 'No fue posible cargar las estaciones.',
  'Details': 'Detalles',
  'Disabled': 'Deshabilitada',
  'Enabled': 'Habilitada',
  'Identifier': 'Identificador',
  'It does not show up in the catalogue the partner reads.': 'No aparece en el catálogo que consulta el socio.',
  'It has never reported since it was registered — different from being offline now.': 'Nunca dio señal desde el registro — distinto de estar offline ahora.',
  'Last signal': 'Última señal',
  'Location': 'Ubicación',
  'Name': 'Nombre',
  'Never connected': 'Nunca conectó',
  'No': 'No',
  'No address': 'Sin dirección',
  'No connector': 'Sin conector',
  'No coordinates': 'Sin coordenada',
  'No station matches this filter.': 'Ninguna estación corresponde a este filtro.',
  'No tariff': 'Sin tarifa',
  'Nothing: this station is correctly registered.': 'Nada: esta estación está registrada correctamente.',
  'Number': 'Número',
  'Offline': 'Offline',
  'Online': 'Online',
  'Owner account': 'Cuenta dueña',
  'Partners': 'Socios',
  'Registration': 'Registro',
  'Registration data': 'Datos de registro',
  'Search by name or number': 'Buscar por nombre o número',
  'Stations': 'Estaciones',
  'Status now': 'Estado ahora',
  'The partner app searches by radius, so the station never appears in the results.': 'La app del socio busca por radio, así que la estación nunca aparece en el resultado.',
  'The partner displays the station without saying where it is.': 'El socio muestra la estación sin decir dónde queda.',
  'The partner does not know the price it will charge its own user.': 'El socio no sabe el precio que le cobrará a su usuario.',
  'There is nothing to start: the partner user cannot charge here.': 'No hay qué iniciar: el usuario del socio no puede cargar aquí.',
  'What is wrong': 'Qué está mal',
  'Yes': 'Sí',
  'connectors': 'conectores',
  'never': 'nunca',
  'no address': 'sin dirección',
  'none': 'ninguno',
  'Cancel': 'Cancelar',
  'Created': 'Creado',
  'Duration': 'Duración',
  'Energy': 'Energía',
  'Event': 'Evento',
  'Payment': 'Pago',
  'Station': 'Estación',
  'Transactions': 'Transacciones',
  'Type': 'Tipo',
  'Every station reached by an active contract, in both directions, with the contract it belongs to and what would reach the partner broken.': 'Toda estación alcanzada por un contrato activo, en los dos sentidos, con el contrato al que pertenece y lo que llegaría roto al socio.',
  'Accepted at': 'Aceptado el',
  'Accepted by': 'Aceptado por',
  'Accounts in scope': 'Cuentas en el alcance',
  'Author': 'Autor',
  'Detail': 'Detalle',
  'Ended at': 'Terminó el',
  'Expires at': 'Expira el',
  'Generated by': 'Generado por',
  'IP': 'IP',
  'Includes new sub-accounts': 'Incluye nuevas subcuentas',
  'Invite': 'Invitación',
  'Numbers': 'Números',
  'OCPP code': 'Código OCPP',
  'Origin': 'Origen',
  'Started at': 'Comenzó el',
  'Trail': 'Rastro',
  'User': 'Usuario',
  'The token is shown only once, when the invite is generated: it is stored as a hash and cannot be displayed again. To hand it over once more, generate a new invite.': 'El token se muestra una única vez, al generar la invitación: se guarda como hash y no puede mostrarse otra vez. Para entregarlo de nuevo, genera una nueva invitación.',
  'Could not load the connectors.': 'No fue posible cargar los conectores.',
  'List': 'Lista',
  'Map': 'Mapa',
  'No station in this filter has coordinates to show on the map.': 'Ninguna estación de este filtro tiene coordenada para mostrar en el mapa.',
  'Open details': 'Abrir detalle',
  'Ready for the partner': 'Lista para el socio',
  'See only those': 'Ver solo esas',
  'Showing the first': 'Mostrando las primeras',
  'The partner cannot use it': 'El socio no puede usarla',
  'This station has no connector registered.': 'Esta estación no tiene conector registrado.',
  'Usable, with wrong data': 'Usable, con dato incorrecto',
  'never reported': 'nunca reportó',
  'no own tariff': 'sin tarifa propia',
  'no power': 'sin potencia',
  'no type': 'sin tipo',
  'of the filtered stations have no coordinates and do not appear on the map.': 'de las estaciones del filtro no tienen coordenada y no aparecen en el mapa.',
  'own tariff': 'tarifa propia',
  'stations in this filter.': 'estaciones de este filtro.',
  'Available': 'Disponible',
  'Preparing': 'Preparando',
  'Charging': 'Cargando',
  'Suspended by the vehicle': 'Suspendido por el vehículo',
  'Suspended by the station': 'Suspendido por la estación',
  'Finishing': 'Finalizando',
  'Reserved': 'Reservado',
  'Faulted': 'En falla',
  'Charging group full': 'Energía no disponible',
  'Unavailable': 'No disponible',
  'Failure': 'Falla',
  'Most stations in': 'Más estaciones en',
  'Fewer stations': 'menos estaciones',
  'More stations': 'más estaciones',
  'on the map without an address': 'en el mapa sin dirección',
  'The map could not be drawn. The rest of the screen keeps working.': 'No fue posible dibujar el mapa. El resto de la pantalla sigue funcionando.',
  'Density': 'Densidad',
  'The density layer failed:': 'La capa de densidad falló:',
  'Points': 'Puntos',
  'with problems': 'con problema',
  'No registration problem in this filter.': 'Ningún problema de registro en este filtro.',
  'Nothing missing: the partner can use these.': 'No falta nada: el socio puede usarlas.',
  'Clear filter': 'Limpiar filtro',
  'filtering by': 'filtrando por',
  'Audit': 'Auditoría',
  'Contracts': 'Contratos',
  'Diagram': 'Diagrama',
  'Only available on an effective contract where you receive stations': 'Solo disponible en contrato efectivo en el que recibes estaciones',
  'Invalid token. Check whether you copied the whole code.': 'Token inválido. Verifica si copiaste el código completo.',
  'Could not check the token now. Try again in a moment.': 'No fue posible verificar el token ahora. Intenta de nuevo en unos instantes.',
  'Could not accept the invite now. Try again in a moment.': 'No fue posible aceptar la invitación ahora. Intenta de nuevo en unos instantes.',
  'wants your app to display': 'quiere que muestres',
  'All partners': 'Todos los socios',
  'Could not download the CSV. The list on screen is unchanged.': 'No se pudo descargar el CSV. La lista en pantalla no fue afectada.',
  'Download CSV': 'Descargar CSV',
  'Could not load the charges. Try again.': 'No fue posible cargar las recargas. Intenta de nuevo.',
  'No cross charges in this period.': 'Ninguna recarga cross en este período.',
  'Charge': 'Recarga',
  'Connector': 'Conector',
  'Origin tenant': 'Tenant de origen',
  'Energy (kWh)': 'Energía (kWh)',
  'Revenue': 'Ingresos',
  'in progress': 'cargando',
  'Totals for the filtered period': 'Totales del período filtrado',
  'Charges': 'Recargas',
  'To invoice': 'Por facturar',
  'Users from other tenants are always masked': 'Usuarios de otros tenants siempre enmascarados',
  'Page': 'Página',
  'charges': 'recargas',
  'Previous': 'Anterior',
  'Next': 'Siguiente',
  'Submit': 'Enviar',
  'Station no longer registered': 'Estación ya no registrada',
  'Preparing...': 'Preparando...',
  'Charging...': 'Cargando...',
  'Invite revoked': 'Invitación revocada',
  'Invite expired': 'Invitación expirada',
  'Token used': 'Token utilizado',
  'Invalid token attempt': 'Intento de token inválido',
  'Scope changed': 'Alcance modificado',
  'Subaccount included automatically': 'Subcuenta incluida automáticamente',
  'Connection suspended': 'Conexión suspendida',
  'Connection reactivated': 'Conexión reactivada',
  'Connection revoked': 'Conexión revocada',
  'Success': 'Éxito',
  'Blocked': 'Bloqueado',
  'All events': 'Todos los eventos',
  'Could not load the history. Try again.': 'No fue posible cargar el historial. Intenta de nuevo.',
  'No events in this period.': 'Ningún evento en este período.',
  'Date / time': 'Fecha / hora',
  'Responsible': 'Responsable',
  'Partner': 'Socio',
  'Result': 'Resultado',
  'no human author': 'sin autor humano',
  'unnamed tenant': 'tenant sin nombre',
  'unknown': 'desconocido',
  'attempt': 'intento',
  'Read-only trail: events cannot be edited or deleted.': 'Registro de solo lectura: los eventos no pueden editarse ni borrarse.',
  'events': 'eventos',
  'My hierarchy → partners': 'Mi jerarquía → socios',
  'Flow': 'Flujo',
  'Mind map': 'Mapa mental',
  'Mind map: your head account at the center, subaccounts on the left, partners around. Solid arrow = I share; dashed arrow back = I receive.': 'Mapa mental: tu cuenta matriz en el centro, subcuentas a la izquierda, socios alrededor. Flecha llena = yo comparto; flecha punteada de vuelta = yo recibo.',
  'Showing only the selected partner links — click it again to see all.': 'Mostrando solo las conexiones del socio seleccionado — haz clic de nuevo para ver todas.',
  'Click a partner on the right to isolate its links.': 'Haz clic en un socio a la derecha para aislar sus conexiones.',
  'Could not load the map. Try again.': 'No fue posible cargar el mapa. Intenta de nuevo.',
  'No contracts or open invites to draw yet.': 'Ningún contrato o invitación abierta para dibujar aún.',
  'MY ACCOUNTS': 'MIS CUENTAS',
  'PARTNERS': 'SOCIOS',
  'head account': 'matriz',
  'subaccount': 'subcuenta',
  'Active bidirectional contract — both apps display': 'Contrato bidireccional activo — las dos apps muestran',
  'Active one-way contract — only the partner displays': 'Contrato unilateral activo — solo el socio muestra',
  'Pending invite — nothing shared yet': 'Invitación pendiente — nada compartido aún',
  'Suspended — contract stands, nothing displayed': 'Suspendido — contrato mantenido, nada mostrado',
  'Last session': 'Última sesión',
  'Partner app': 'App del socio',
  'Show these stations in my app': 'Mostrar estas estaciones en mi app',
  'Stations I receive': 'Estaciones que recibo',
  'Stations I share': 'Estaciones que comparto',
  'Status': 'Estado',
  'Without an app the partner can share stations but receives none, so the contract cannot be bidirectional.': 'Sin app el socio puede compartir estaciones, pero no recibe ninguna — entonces el contrato no puede ser bidireccional.',
  'Partner accounts in this contract': 'Cuentas del socio en este contrato',
  'Your account token': 'Token de tu cuenta',
  'Hand this token to a partner so they can invite your account. Whoever has it can only invite you — accepting is still your decision.': 'Entrega este token a un socio para que invite a tu cuenta. Quien lo tiene solo puede invitarte — aceptar sigue siendo tu decisión.',
  'Could not load the token. Try again.': 'No fue posible cargar el token. Intenta de nuevo.',
  'This account has no token yet.': 'Esta cuenta aún no tiene token.',
  'Copy': 'Copiar',
  'Expired on': 'Venció el',
  'renew to share again': 'renueva para volver a compartir',
  'Valid until': 'Válido hasta',
  'Does not expire': 'No vence',
  'renewed on': 'renovado el',
  'does not expire': 'no vence',
  '7 days': '7 días',
  '30 days': '30 días',
  '90 days': '90 días',
  'Renew': 'Renovar',
  'Generate token': 'Generar token',
  'Renewing invalidates the current token.': 'Renovar invalida el token actual.',
  'Renewing invalidates the current token: partners who have it can no longer invite you. Continue?': 'Renovar invalida el token actual: los socios que ya lo tienen dejan de poder invitarte. ¿Continuar?',
  'Open contract': 'Abrir contrato',
  'Partner account token': 'Token de la cuenta socia',
  'Check': 'Verificar',
  'Checking...': 'Verificando...',
  'Ask the partner for the token shown on their Interoperability screen.': 'Pide al socio el token que aparece en su pantalla de Interoperabilidad.',
  'Could not check this token now. Try again in a moment.': 'No fue posible verificar este token ahora. Intenta de nuevo en unos instantes.',
  'The current token could not be read. Generating a new one invalidates whatever token exists, and partners holding it will no longer be able to invite you.': 'No se pudo leer el token actual. Generar uno nuevo invalida el token que exista, y los socios que lo tengan ya no podrán invitarte.',
  'Renew the account token?': '¿Renovar el token de la cuenta?',
  'Partners who already have the current token will no longer be able to invite you. Send them the new one.': 'Los socios que ya tienen el token actual dejan de poder invitarte. Envíales el nuevo.',
  'Revoke the contract with this partner?': '¿Revocar el contrato con este socio?',
  'Suspend this contract?': '¿Suspender este contrato?',
  'Suspending hides your {0} stations in the app of {1} until you reactivate.': 'Suspender ocultará sus {0} estaciones en la app de {1} hasta que reactive.',
  'Suspending hides the {0} stations of {1} in your app until you reactivate.': 'Suspender ocultará las {0} estaciones de {1} en su app hasta que reactive.',
  'Suspending hides your {0} stations in the app of {1}, and the {2} stations of theirs in your app, until you reactivate.': 'Suspender ocultará sus {0} estaciones en la app de {1}, y las {2} estaciones de él en su app, hasta que reactive.',
  'Revoking is not reversible: the stations stop being displayed on both sides, and reconnecting requires a new invite.': 'Revocar no es reversible: las estaciones dejan de mostrarse en los dos lados, y reconectar exige una nueva invitación.',
  '— awaiting acceptance': '— esperando aceptación',
  '— contract ended': '— contrato finalizado',
  'does not receive — one-way contract': 'no recibe — contrato unilateral',
  '{0} stations shown in my app': '{0} estaciones mostradas en mi app',
  '{0} stations received · hidden in the app': '{0} estaciones recibidas · ocultas en la app',
  '{0} in the invite · awaiting acceptance': '{0} en la invitación · esperando aceptación',
  '0 · contract ended': '0 · contrato finalizado',
  'stations · {0} account': 'estaciones · {0} cuenta',
  'stations · {0} accounts': 'estaciones · {0} cuentas',
  'Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'Activar o desactivar la recepción no altera el contrato: solo esconde las estaciones del socio en tu app.',
  'Could not complete the action. Nothing was changed.': 'No fue posible completar la acción. Nada fue alterado.',
  'Contract revoked.': 'Contrato revocado.',
  'Contract suspended.': 'Contrato suspendido.',
  'Contract reactivated.': 'Contrato reactivado.',
  'Stations now visible in your app.': 'Las estaciones pasan a aparecer en tu app.',
  'Stations hidden in your app.': 'Estaciones escondidas en tu app.',
  'Could not load interoperability data.': 'No fue posible cargar los datos de interoperabilidad.',
  'Could not load the charges.': 'No fue posible cargar las recargas.',
  'Could not load the history.': 'No fue posible cargar el historial.',
  'Could not load the map.': 'No fue posible cargar el mapa.',
  'This tab is delivered in its own task.': 'Esta pestaña se entrega en su propia tarea.',
  'Firmware Update History': 'Historial de Actualización de Firmware',
  'Search by station': 'Buscar por estación',
  Charger: 'Cargador',
  'Update date': 'Fecha de actualización',
  'MCU previous version': 'MCU versión anterior',
  'MCU current version': 'MCU versión actual',
  'Initial version': 'Versión inicial',
  'Gateway previous version': 'Gateway versión anterior',
  'Gateway current version': 'Gateway versión actual',
  'Updated by': 'Actualizado por',
  'Remote update': 'Actualización remota',
  'Updates in period': 'Actualizaciones en el período',
  'Last update': 'Última actualización',
  'Firmware History': 'Historial de Firmware',
  'Charger / Station': 'Cargador / Estación',
  'Total records': 'Total de registros',
  'Update records': 'Registros de actualización',
  results: 'resultados',
  'No records found': 'No se encontraron registros',
  Showing: 'Mostrando',
  of: 'de',
  Restart: 'Reiniciar',
  // MV2-1263
  'Erro ao carregar configuração de push':
    'Error al cargar la configuración de push',
  'Informe um valor maior ou igual a 1': 'Ingrese un valor mayor o igual a 1',
  'Limite atualizado com sucesso!': '¡Límite actualizado con éxito!',
  'Não foi possível atualizar o limite.':
    'No fue posible actualizar el límite.',
  'Limite de destinatários por push': 'Límite de destinatarios por push',
  Salvar: 'Guardar',
  'O filtro selecionado retornou': 'El filtro seleccionado retornó',
  'usuários, porém o limite máximo por envio é de':
    'usuarios, pero el límite máximo por envío es de',
  'destinatários. Refine os filtros da campanha ou utilize a opção de envio para todo o tenant.':
    'destinatarios. Refine los filtros de la campaña o utilice la opción de envío para todo el tenant.',
  'A audiência': 'La audiencia',
  'excede o limite de': 'excede el límite de',
  'destinatários. Refine o filtro ou use o envio para todo o tenant.':
    'destinatarios. Refine el filtro o use el envío para todo el tenant.',
  'Excede o limite de': 'Excede el límite de',
  'General View': 'Visión General',
  'Not Available': 'No Disponible',
  Home: 'Início',
  'User charged': 'Usuario cargó',
  'Users charged': 'Usuarios cargaron',
  'Registered user': 'Usuario registrado',
  'Registered users': 'Usuarios registrados',
  'CONSUMED kWh TOTAL': 'TOTAL DE kWh CONSUMIDOS',
  'Period Total': 'Total en el periodo',
  Period: 'Periodo',
  Indicators: 'Indicadores',
  Support: 'Soporte',
  'Required fields': 'Campos requeridos',
  Submit: 'Enviar',
  'Type 1': 'Tipo 1',
  'Type 2': 'Tipo 2',
  'Type 3': 'Tipo 3',
  Available: 'Disponible',
  Unavailable: 'Indisponible',
  Preparing: 'Preparando',
  Charging: 'Cargando',
  'Not Charging': 'Sin Cargar',
  Finishing: 'Terminando',
  Reserved: 'Reservado',
  Faulted: 'Com defeito',
  Unspecified: 'No especificado',
  'ChargeBox ID': 'ID del Cargador',
  'Endpoint address': 'Dirección Web',
  'Registration status': 'Status de registro',
  Accepted: 'Aceito',
  Declined: 'Recusado',
  Rejected: 'Rejeitado',
  'Insert connector status after start/stop transaction':
    'Inserir o status do conector após iniciar/parar a transação',
  Street: 'Calle',
  'House number': 'Número de calle',
  'Zip code': 'Código Postal',
  City: 'Ciudad',
  State: 'Departamento',
  Country: 'País',
  Description: 'Descripción',
  'Admin address': 'Endereço admin',
  'Location Latitude': 'Latitud (Ubicación)',
  'Location Longitude': 'Longitud (Ubicación)',
  Type: 'Tipo',
  Public: 'Pública',
  Private: 'Privada',
  'Show location': 'Mostrar ubicación',
  'Open 24 hours': 'Abierto 24 horas',
  'Open time': 'Hora de apertura',
  'Close time': 'Hora de cierre',
  'Customize per day': 'Personalizar por día',
  'Set opening and closing hours for each day of the week': 'Configura los horarios de apertura y cierre para cada día de la semana',
  'Automatically stop charging when station closes': 'Detener cargas automáticamente al cerrar',
  'Closed': 'Cerrado',
  'Period': 'Período',
  'Sunday': 'Domingo',
  'Monday': 'Lunes',
  'Tuesday': 'Martes',
  'Wednesday': 'Miércoles',
  'Thursday': 'Jueves',
  'Friday': 'Viernes',
  'Saturday': 'Sábado',
  'At least one day must have operating hours': 'Al menos un día debe tener horario de funcionamiento',
  'Start time must be before end time for all periods': 'La hora de inicio debe ser anterior a la de cierre en todos los períodos',
  'Minimum reservation': 'Reserva mínima',
  Accessibility: 'Acessibilidade',
  'Free publicly accessible': 'Livre acessível ao público',
  'Restricted access': 'Acesso restrito',
  'Paying publicly accessible': 'Pagável acessível ao público',
  'Test station': 'Estação de teste',
  'Authentication mode': 'Modo de autenticação',
  'Max. time future': 'Max. tempo futuro',
  'Dynamic info available': 'Informação dinâmica disponível',
  True: 'Verdadeiro',
  False: 'Falso',
  'Connector ID': 'ID del Conector',
  'Connector type': 'Tipo de conector',
  'Power Max': 'Potencia máxima (kW)',
  'Has Payment': 'La recarga se cobrará',
  'Cost per kWh': 'Costo (USD) por kWh',
  'Cost per kWh (R$)': 'Costo (USD) por kWh',
  'Cost per duration': 'Costo (USD) por tiempo(min)',
  'Income per kWh': 'Ingreso (USD) por kWh',
  'Income per kWh (R$)': 'Ingreso (USD) por kWh',
  'Income per Duration': 'Ingreso (USD) por tiempo(min)',
  'Income per Transaction': 'Ingreso (USD) por Inicio de Recarga',
  'Tax Income': 'Impuesto por Receita (%)',
  'Additional Note': 'Nota adicional',
  Name: 'Nombre',
  'Last name': 'Apellido',
  Birthday: 'Aniversário',
  'User Active': 'Usuario Activo',
  'Choose Connector ID': 'Escolha o id do conector',
  'Choose OCPP ID Tag': 'Escolha o OCPP id tag',
  'Choose Transaction ID': 'Escolha o id da transação',
  'Choose Reset Type': 'Escolha o tipo do reset',
  'Conf Key List': 'Lista de chaves de configuração',
  Select: 'Selecione',
  'Select all': 'Selecionar todas',
  'Reset selection': 'Limpar seleção',
  'Change Availability': 'Cambiar Disponibilidad',
  'Availability Type': 'Tipo de Disponibilidade',
  'Remote Start Transaction': 'Iniciar Transacción Remota',
  'Remote Stop Transaction': 'Detener Transacción Remota',
  Reset: 'Reiniciar',
  'Get Configuration': 'Obtener Configuración',
  'Change Configuration': 'Cambiar Configuración',
  'Key Type': 'Tipo de Clave',
  'Configuration Key': 'Clave de Configuración',
  'Custom Configuration Key': 'Clave de Configuración Personalizada',
  Value: 'Valor',
  'Power Limit': 'Límite de Potencia',
  'Trigger Message': 'Trigger Message',
  'Set Charging Profile': 'Establecer Perfil de Carga',
  'Clear Charging Profile': 'Limpiar Perfil de Carga',
  'Send Local List': 'Enviar lista local',
  'Reserve Now': 'Reservar Ahora',
  'Expiry Date': 'Fecha de Expiración',
  'Get Diagnostics': 'Obtener Diagnóstico',
  'Unlock Connector': 'Desbloquear Conector',
  'Update Firmware': 'Actualice el Firmware',
  'Directory URI': 'URI do diretório',
  'Retries (integer)': 'Tentativas (número inteiro)',
  'Retry Interval (integer)': 'Intervalo de repetição (número inteiro)',
  'Retrieve DateTime Firmware': 'Data e Hora para recuperar',
  Optional: 'Opcional',
  'Task ID': 'ID de la Tarea',
  'OCPP Version': 'Versión OCPP',
  'Operation Name': 'Nombre de la operación',
  Origin: 'Origen',
  'Start Timestamp': 'Hora de inicio',
  'End Timestamp': 'Hora de finalización',
  'Error Message': 'Mensagem de erro',
  Response: 'Resposta',
  'All connectors': 'Todos conectores',
  Tasks: 'Tareas',
  'Choose profile': 'Escolha o perfil',
  Goal: 'Meta',
  Remaining: 'Restante',
  Using: 'Usando',
  'Not using': 'Não usando',
  Phone: 'Teléfono/Celular',
  'User Group': 'Grupo do usuario',
  'New Charging Profile': 'Novo Perfil de Recarga',
  'Edit Charging Profile': 'Editar Perfil de Recarga',
  Edit: 'Editar',
  'Not allowed': 'Sem permissão',
  'Is Hubject Compatible': 'Compatible con Hubject',
  'Is OCPI Compatible': 'Compatible con OCPI',
  'Edit User': 'Editar Usuario',
  'Creating User': 'Registro de usuario',
  'Editing User': 'Editando Usuario',
  'External ID': 'ID Externo',
  'Ocpp Tags': 'OCPP Tags',
  'Payment Charge Type Cost': 'Tipo de facturación para costo',
  'Payment Charge Type Income': 'Tipo de facturación para ingresos',
  'Payment Charge Type KWH': 'Por kWh',
  'Payment Charge Type Duration': 'Por tiempo(min)',
  'Price Profile Activated (Editing is not allowed while the station has an activated Price Profile)':
    'Perfil de Precio Activado (No es posible editar cuando la estación posee un Perfil de Precio Activado)',
  'Payment Charge By Income': 'Facturación por',
  'Payment Charge By Income Station': 'Cargador',
  'Payment Charge By Income Connector': 'Conector',
  Others: 'Otros',
  'Enable Face Reader': 'Habilitar Lector de Rostros',
  'Enable Station': 'Habilitar Estación',
  'Facial Reader - MAC Address': 'Lector facial - Dirección MAC',
  'Reservation enabled': 'Habilitar reserva',
  'Data Transfer': 'Transferencia de datos',
  'Vendor ID': 'ID del fabricante',
  'Message ID': 'ID de mensaje',
  Data: 'Datos',
  'Confirm payment?': '¿Confirmar pago?',
  Yes: 'Sí',
  Cancel: 'Cancelar',
  // Login
  Password: 'Contraseña',
  'Recover password': 'Recuperar contraseña',
  'Forgot your password?': '¿Has olvidado tu contraseña?',
  'Click here': 'Haga clic aquí',
  'Unable to log in. Please check if the email or password is correct.':
    'No se pudo iniciar sesión. Verifique si el correo electrónico o la contraseña son correctos.',
  'User without permission/blocked. Contact the administrator.':
    'Usuario sin permiso/bloqueado. Contacte al administrador.',
  'Error when trying to Login.': 'Error al intentar iniciar sesión.',
  'Login successfully!': '¡Login con éxito!',
  Enter: 'Entrar',

  // Two-Factor Authentication
  'We sent a code to': 'Enviamos un código a',
  'Code expires in': 'El código expira en',
  'Code expired. Request a new one.': 'Código expirado. Solicite uno nuevo.',
  'attempts remaining': 'intentos restantes',
  'Resend code in': 'Reenviar código en',
  'Resend code': 'Reenviar código',
  'Back to login': 'Volver al inicio de sesión',
  'Invalid code. Please try again.': 'Código inválido. Inténtelo de nuevo.',
  'Error verifying code. Please try again.':
    'Error al verificar el código. Inténtelo de nuevo.',
  'Connection error. Please try again.':
    'Error de conexión. Inténtelo de nuevo.',
  'Account temporarily blocked. Try again in 15 minutes.':
    'Cuenta bloqueada temporalmente. Inténtelo de nuevo en 15 minutos.',
  'New code sent to your email.':
    'Nuevo código enviado a su correo electrónico.',
  'Please wait before requesting a new code.':
    'Espere antes de solicitar un nuevo código.',
  'Error sending code. Please try again.':
    'Error al enviar el código. Inténtelo de nuevo.',

  // Recover Password
  'Verification Code': 'Código de Verificación',
  'Check the code in your email.': 'Revisa el código en tu correo electrónico.',
  'Check if the email entered exists.':
    'Compruebe si el correo electrónico introducido existe.',
  'Password recovery': 'Recuperación de contraseña',
  'Enter your email to receive the verification code.':
    'Ingrese su correo electrónico para recibir el código de verificación.',
  'Back to': 'Volver a la página de',
  // Register
  Register: 'Registro',
  'Already have registration?': '¿Ya tienes registro?',
  // Change Password
  'Password changed successfully!': '¡Contraseña alterada con éxito!',
  'The code has expired.': 'El código ha caducado.',
  'Exceeded number of attempts': 'Número de intentos superado',
  'Check that the entered code is valid.':
    'Verifique se o código inserido é válido.',
  'You will be redirected to the Login screen.':
    'Será redirigido a la pantalla de inicio de sesión.',
  'Enter the verification code received in your email and enter your new password':
    'Ingrese el código de verificación recibido en su correo electrónico e ingresa tu nueva contraseña',
  Code: 'Código',
  'New Password': 'Nueva contraseña',
  // Home
  'Search stations': 'Buscar Cargadores',
  'Station started': 'Cargador Iniciado',
  Disconnected: 'Cargador Offline',
  Connected: 'Conectado',
  'Transaction Started': 'Carga Iniciada',
  'Transaction Ended': 'Carga Detenida',
  Failure: 'Falla',
  'Short Recharge': 'Recarga a corto plazo',
  'In use': 'En uso',
  'Total users': 'Usuarios Totales',
  Busy: 'Ocupado',
  Chargeboxes: 'Cargadores',
  Sustainability: 'Sustentabilidad',
  'Cultivated Tree': 'Árbole Cultivado',
  'Cultivated Trees': 'Árboles Cultivados',
  'Estimated cost and revenue in the period':
    'Costo y ingressos estimados en el período',
  Subtitles: 'Subtítulos',
  System: 'Sistema',
  'Admin Panel': 'Panel de Administrador',
  'General settings': 'Configuración General',
  Account: 'Cuenta',
  'View profile': 'Ver perfil',
  Logout: 'Cerrar Sesión',
  // Chargeboxes
  'Search by station name, state, city, or ID':
    'Busque por nombre, departamento, ciudad o ID',
  Report: 'Reporte',
  'Generate Station Report': 'Generar Reporte de Cargador',
  'Report Type': 'Tipo de Reporte',
  'Your plan is CVE lite. Each report type has a limit of {0} downloads per month. The counter is individual per type.':
    'Su plan es CVE lite. Cada tipo de informe tiene un límite de {0} descargas por mes. El contador es individual por tipo.',
  'Unified Report': 'Reporte unificado',
  'Individual Report': 'Reporte individual',
  'Generate Report': 'Generar Reporte',
  'Value Configuration': 'Configuración de Valores',
  'Report by apartment': 'Reporte por apartamento',
  'Download Excel': 'Download Excel',
  'New Station': 'Nueva Estación',
  'All Accounts': 'Todas las Cuentas',
  'Select Account': 'Seleccione la cuenta',
  'Unnamed Account': 'Cuenta sin nombre',
  'All Chargebox Groups': 'Todos los Grupos de Cargadores',
  Account: 'Cuenta',
  'Quantity of Recharges': 'Recargas (Qtde.)',
  Recharges: 'Cargas',
  Connectors: 'Conectores',
  'Edit Chargebox': 'Editar Cargador',
  'Delete Chargebox': 'Eliminar Cargador',
  'Are you sure you want to delete this station? When deleting, all the history already made in it will be lost.':
    '¿Está seguro de que desea eliminar este cargador? Al borrar, se perderá todo el historial ya hecho en ella.',
  Delete: 'Eliminar',
  'You can only upload .jpg/.jpeg/.png file!':
    '¡Solo puede cargar archivos .jpg/.jpeg/.png!',
  'Image must smaller than 10MB!': '¡La imagen debe tener menos de 10 MB!',
  'An image with this name already exists!':
    '¡Ya existe una imagen con este nombre!',
  'Error uploading image!': '¡Error subiendo imagen!',
  // Form Chargebox
  General: 'General',
  'Creating Chargebox': 'Registro de la estación',
  'Editing Chargebox': 'Editando Cargador',
  'Address/Location': 'Dirección/Ubicación',
  Payment: 'Pago',
  'Hours of Operation': 'Horas de oficina',
  'Access Control': 'Control de Acceso',
  Owners: 'Propietarios',
  'Select users': 'Seleccionar usuarios',
  'Users with access': 'Usuarios con acceso',
  'Owners can manage who can access the private station.':
    'Los propietarios pueden administrar quién puede acceder a la estación privada.',
  'Users who only have access to the private station.':
    'Usuarios que solo tienen acceso a la estación privada.',
  'The ChargeBox ID field is mandatory.':
    'El campo ChargeBox ID es obligatorio.',
  'The ChargeBox ID field cannot contain blanks.':
    'El campo ID de ChargeBox no puede contener espacios en blanco.',
  'The Description field is mandatory.': 'El campo Descripción es obligatorio.',
  'The Type field cannot be null.': 'El campo Tipo no puede ser nulo.',
  'The Latitude field must be filled in.': 'El campo Latitud debe ser llenado.',
  'The Latitude field must be between -90 and 90.':
    'El campo Latitud debe estar entre -90 y 90.',
  'The Longitude field must be filled in.':
    'El campo Longitud debe ser llenado.',
  'The Facial Reader MAC Address field is mandatory.':
    'El campo Lector Facial Dirección MAC es obligatorio.',
  'Opening time must be defined': 'El horario de apertura debe ser definido',
  'Closing time must be defined': 'Se debe definir la hora de cierre',
  'The connector type field cannot be null.':
    'El campo tipo de conector no puede ser nulo.',
  'Required field': 'Campo obligatorio',
  'Station created successfully!': '¡Estación creada con éxito!',
  'Station updated successfully!': '¡Estación actualizada con éxito!',
  'Unable to perform the operation. Make sure the fields are filled in correctly.':
    'No se puede realizar la operación. Asegúrese de que los campos se completen correctamente.',
  'There is already a station registered with this identifier.':
    'Ya existe una estación registrada con este identificador.',
  Photos: 'Fotos',
  'User not found!': '¡Usuario no encontrado!',
  'Please enter a valid CPF to continue.':
    'Por favor, ingrese un número de cédula válido para continuar.',
  // Chargebox Groups
  'Chargebox Groups': 'Grupo de Cargadores',
  'Search by name': 'Buscar por Nombre',
  'Search by name, email, document or phone':
    'Buscar por nombre, correo electrónico, documento o teléfono',
  'New chargebox group': 'Nuevo Grupo de Cargadores',
  Address: 'Dirección',
  // Users
  User: 'Usuario',
  Users: 'Usuarios',
  'New user': 'Nuevo Usuario',
  Car: 'Auto',
  'Recharges Done': 'Cargas Realizadas',
  'kWh Consumed': 'kWh Consumidos',
  Document: 'Documento',
  'Active Users': 'Usuarios Activos',
  'Active Vehicles': 'Vehículos activos',
  'Not registered': 'No registrado',
  'The Name field is mandatory.': 'El campo Nombre es obligatorio.',
  'The E-mail field is mandatory.': 'El campo E-mail es obligatorio.',
  'Invalid E-mail': 'Email inválido',
  'The Name field must only contain letters.':
    'El campo Nombre solo debe contener letras.',
  'The Password field is mandatory.': 'El campo Contraseña es obligatorio.',
  'The Phone field is mandatory.': 'El campo Teléfono es obligatorio.',
  // Ocpp Tags
  'Creating OCPP Tag': 'Registro de OCPP Tag',
  'Editing OCPP Tag': 'Edición de OCPP Tag',
  Owner: 'Dueño',
  USER: 'USUARIO',
  CARD: 'TARJETA',
  'Search By TAG ID': 'Busque por Tag IDs',
  'New OCPP Tag': 'Nuevo OCPP Tag',
  'Ocpp Tag successfully deleted!': '¡Ocpp Tag eliminada con éxito!',
  'Unable to delete Ocpp Tag.': 'No se puede eliminar la Ocpp Tag.',
  'Edit Ocpp Tag': 'Editar Ocpp Tag',
  'Delete Ocpp Tag': 'Eliminar Ocpp Tag',
  'Are you sure you want to delete this Ocpp Tag? When deleting, all the history already made in it will be lost.':
    '¿Está seguro de que desea eliminar este Ocpp Tag? Al borrar, se perderá todo el historial ya hecho en ella.',
  'Does not own': 'No tiene',
  'Owner ID': 'Identificador de Propietario',
  'Owner User': 'Propietario',
  'Card User': 'Usuario de la Tag',
  'OCPP Tag successfully created!': '¡OCPP Tag creada con éxito!',
  'OCPP Tag successfully updated!': '¡OCPP Tag actualizada con éxito!',
  'Inactivate Tag': 'Inactivar Tag',
  // Unknown Ocpp Tags
  Attempts: 'Intentos',
  'Last attempt': 'Ultimo intento',
  'Approve / Delete': 'Aprobar / Eliminar',
  Approve: 'Aprobar',
  'RFID Tag successfully approved!': '¡Etiqueta RFID aprobada con éxito!',
  'Error when trying to approve RFID Tag':
    'Error al intentar aprobar la etiqueta RFID',
  'RFID Tag successfully deleted!': '¡Etiqueta RFID eliminada con éxito!',
  'Error when trying to delete RFID Tag':
    'Error al intentar quitar la etiqueta RFID',
  // Operations
  Operations: 'Operaciones',
  Commands: 'Comandos',
  Stations: 'Estaciones',
  Selected: 'Seleccionado',
  'Charging Profiles': 'Perfiles de Recarga',
  'Charging Profile PK': 'Perfil de Recarga ID',
  'Stack Level': 'Stack Level',
  'Profile Purpose': 'Propósito del perfil',
  'Profile Kind': 'Tipo de Perfil',
  'Recurrency Kind': 'Tipo de Recurrencia',
  'Valid From': 'Válido Desde',
  'Valid To': 'Válido Hasta',
  'Add new charging profile': 'Agregar nuevo perfil de recarga',
  'Edit/ See Details': 'Cambiar/Ver detalles',
  'Identification Type': 'Tipo de identificación',
  'Search to Select': 'Pesquise para seleccionar',
  'Payment Type': 'Tipo de Pago',
  'Generate payment on recharge': 'Generar pago en recarga',
  'Start Date/Time': 'Fecha y hora de inicio',
  'Stop Date/Time': 'Fecha y hora de parada',
  'Clear Cache': 'Limpiar Cache',
  'Filter Type': 'Tipo de Filtro',
  'Charging Profile ID': 'ID del Perfil de Carga',
  'Other Parameters': 'Otros Parámetros',
  'Charging Profile Purpose': 'Propósito del Perfil de Carga',
  'Stack Level (integer)': 'Nivel de pila (número entero)',
  'List Version': 'Versión de la Lista',
  'Update Type': 'Tipo de Actualización',
  Full: 'Completa',
  Differential: 'Diferencial',
  'Search item to add/update': 'Buscar elemento para agregar/actualizar',
  'Add to list': 'Agregar a la lista',
  'Add / Update List': 'Lista de Agregar / Actualizar',
  'One tag per line': 'Una etiqueta por línea',
  'Search item to delete': 'Buscar elemento para eliminar',
  'Delete List': 'Lista de Eliminación',
  // Transactions
  Transactions: 'Transacción',
  'All Tags': 'Todas las Etiquetas',
  'All Stations': 'Todas los Cargadores',
  'All Revenue Status': 'Todo el Estado de Ingresos',
  'Search by ID or Station Name': 'Buscar por ID o nombre de cargador',
  'Recharge (ID)': 'Carga (ID)',
  'Connector (ID)': 'Conector (ID)',
  Station: 'Estación',
  'User (Tag)': 'Usuario (Tag)',
  'Start - End': 'Inicio - Fin',
  Duration: 'Duración',
  'Income ($)': 'Ingresos  ($)',
  Energy: 'Energía',
  'Edit Payment': 'Editar Pago',
  'Unable to download the .xlsx file.':
    'No se puede descargar el archivo .xlsx.',
  'The following transactions will have payment confirmed: ':
    'Las siguientes transacciones tendrán pago confirmado: ',
  'Payments successfully confirmed!': '¡Pagos confirmados con éxito!',
  'Error when trying to confirm payments!':
    '¡Error al intentar confirmar los pagos!',
  'Approve (': 'Aprobar (',
  ') Transactions': ') Transacciones',
  'Approve Transactions': 'Aprobar transacciones',
  'Must select at least one transaction to perform action!':
    '¡Debe seleccionar al menos una transacción para realizar la acción!',
  'The query is limited to 10,000 transactions!':
    '¡La consulta está limitada a 10,000 transacciones!',
  'The report exceeds the allowed limit of {0} transactions. Adjust the filters and try again.':
    'El informe supera el límite permitido de {0} transacciones. Ajuste los filtros e intente nuevamente.',
  // Indicators
  'All Users': 'Todos los Usuarios',
  Days: 'Días',
  'Duration at last': 'Duración en los últimos',
  'Recharges at last': 'Recargas en los últimos',
  'Consumption at last': 'Consumo en los últimos',
  'Autonomy at last': 'Autonomía en los últimos',
  'Lenght of stay at last': 'Duración de la estadía en los últimos',
  'Most popular times at last': 'Horas más populares en los últimos',
  'Registered Vehicle Brands': 'Marcas de vehículos registrados',
  // Alerts
  Alerts: 'Alertas',
  'Search By Name or ChargeboxId (below the name)':
    'Buscar por nombre o ID de cuadro de cargo (debajo del nombre)',
  Place: 'Dirección',
  Date: 'Fecha',
  Event: 'Evento',
  Undefined: 'No Definido',
  // Push Notification
  'Send a Push Notification to users phone':
    'Envía una Notificación Push en el móvil de los usuarios',
  Message: 'Mensaje',
  // Support
  'Send us a message and we will get in touch':
    'Envíanos un mensaje y nos pondremos en contacto',
  Subject: 'Tema',
  'General Subjects': 'Temas generales',
  Complaint: 'Queja',
  Suggestion: 'Sugerencia',
  // Others
  'Empty list': 'Lista vacía',
  'There are no event records': 'No hay registros de eventos',
  'There are no chargebox records': 'No hay registros de cargadores',
  'There are no transaction records': 'No hay registros de transacciones',
  Autonomy: 'Autonomía',
  'Station ID': 'ID del Cargador',
  Error: 'Error',
  'Creating Chargebox Group': 'Registro de Grupo de Cargadores',
  'Editing Chargebox Group': 'Edición de Grupo de Cargadores',
  'This website uses cookies to enhance the user experience':
    'Este sitio web utiliza cookies para mejorar su experiencia',
  'I Understand': 'Comprendido',
  'Privacy Policy': 'Política de privacidad',
  'By continuing, you agree to our': 'Al continuar, aceptas nuestra',
  'Connector status': 'Estado del conector',
  Maintenance: 'Mantenimiento',
  Hidden: 'Oculto',
  connector_unavailable: 'Sin comunicacion',
  Automatic: 'Automático',
  Consumption: 'Consumo',
  // Vouchers
  Vouchers: 'Vouchers',
  'Creating voucher': 'Registro de voucher',
  'Complete selection': 'Selección completa',
  'No users selected': 'No hay usuarios seleccionados',
  'Select users for the voucher': 'Seleccionar usuarios para el voucher',
  Guests: 'Invitados',
  Search: 'Buscar',
  // Dynamic Pricing
  'Pricing Profiles': 'Perfiles de Precios',
  'Create profile': 'Crear perfil',
  'Profile name': 'Nombre de perfil',
  'Fill in the profile name': 'Complete el nombre del perfil',
  'Read only': 'Solo lectura',
  'Edit exception': 'Editar excepción',
  'View exception': 'Ver excepción',
  'Read only — this profile is not available for editing.':
    'Solo lectura — este perfil no está disponible para edición.',
  Continue: 'Continuar',
  'No profiles found': 'No se encontraron perfiles',
  'applied charger': 'cargador aplicado',
  'applied chargers': 'cargadores aplicados',
  'Creating the profile': 'Creando el perfil',
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  'Download log': 'Descargar el registro',
  'Clear filters': 'Limpiar filtros',
  'Downloading logs for viewing...': 'Descargando registros para ver...',
  'Select a date range to download old logs:':
    'Seleccione un rango de fechas para descargar registros antiguos:',
  recent: 'recientes',
  'Downloading...': 'Descargando...',
  Financial: 'Financiero',
  'Order by:': 'Ordenar por:',
  'Chronological order': 'Data da Recarga',
  'Financial movement': 'Data de Pagamento',
  'Error resending invoice!': '¡Error al reenviar la factura!',
  'Invoice resent successfully!': '¡La factura se reenvió correctamente!',
  'Oops! It seems that something went wrong when issuing the invoice. Do you want to try again?':
    '¡Ups! Parece que algo salió mal al emitir la factura. ¿Quieres intentarlo de nuevo?',
  Details: 'Detalles',
  'All transactions': 'Todas las transacciones',
  'Advanced Settings': 'Configuración Avanzada',
  'Create Configuration': 'Crear Configuración',
  'Edit Configuration': 'Editar Configuración',
  'Select chargers': 'Seleccionar cargadores',
  Phase: 'Fase',
  Tension: 'Tensión (V)',
  'Charging Rate Unit': 'Unidad de carga',
  'Technical settings': 'Configuraciones técnicas',
  'Single Phase': 'Fase única',
  'Two Phase': 'Bifásico',
  'Three Phase': 'Tres fases',
  'Add chargers': 'Agregar cargador(es)',
  'Edit SmartCharging': 'Editar Smart Charging',
  'Create SmartCharging': 'Criar Smart Charging',
  Deposits: 'Depósitos',
  'The report is being generated and will be sent to the email registered in the system.':
    'El informe se está generando y se enviará al correo electrónico registrado en el sistema.',
  'Price calculation based on the energy of the transaction. For example: R$ 2.00/kWh':
    'Cálculo de precio basado en la energía de la transacción. Por ejemplo: R$ 2,00/kWh.',
  'Price calculation based on the duration of the transaction. For example: R$ 1.00/minute.':
    'Cálculo de precio basado en la duración de la transacción. Por ejemplo: R$ 1,00/minuto.',
  'Flat price per start. For example: R$ 5.00/start.':
    'Precio único por inicio realizado. Por ejemplo: R$ 5,00/inicio.',
  "Price based on the duration of the charger's idle time, i.e., the period after the transaction ends when the vehicle remains connected and occupying the charger (finishing state). For example: R$ 5.00/minute of finishing.":
    'Precio por la duración de la inactividad del cargador, es decir, el período después de la finalización de la transacción en que el vehículo permanece conectado y ocupando el cargador (estado de finalización). Por ejemplo: R$ 5,00/minuto de finalización.',
  'Flat price to use the reservation function. For example: R$ 5.00/reservation.':
    'Precio único para usar la función de reserva. Por ejemplo: R$ 5,00/reserva.',
  'System operation fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the fee is 5%, so the operation fee should add R$ 5.00 to the final charging amount.':
    'Tasa de operación del sistema, que debe aplicarse después de la integración de los costos de la recarga. Por ejemplo: El monto final de la transacción es de R$ 100,00, y la tasa es del 5%, por lo que la tasa de operación debe agregar R$ 5,00 al monto final de la recarga.',
  'Tax fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the tax is 15%, so the tax fee should add R$ 15.00 to the final charging amount.':
    'Tasa de impuestos, que debe aplicarse después de la integración de los costos de la recarga. Por ejemplo: El monto final de la transacción es de R$ 100,00, y el impuesto es del 15%, por lo que la tasa de impuestos debe agregar R$ 15,00 al monto final de la recarga.',
  'Amount paid by the operator for energy consumption.':
    'Cantidad pagada por el operador por el consumo de energía.',
  Exception: 'Definir excepciones',
  'Cancel Idle Payment': 'Cancelar pago inactivo',
  'Confirm cancelation of idle payment?':
    '¿Confirmar cancelación de pago inactivo?',
  'Idle Payment Canceled': 'Pago inactivo cancelado',
  'Idle payment canceled successfully!':
    '¡Pago inactivo cancelado exitosamente!',
  'Disabled Stations': 'Estaciones deshabilitadas',
  Current: 'Corriente (A)',
  Power: 'Potencia (W)',
  // OCPI: chave própria, a 'Power' global diz (W) e a potência do conector é exibida em kW.
  'Connector power': 'Potencia',
  Intervals: 'Intervalos',
  Beginning: 'Inicio',
  End: 'Final',
  'Charging Profile created successfully': 'Perfil de carga creado con éxito',
  'Charging Profile updated successfully':
    'Perfil de carga actualizado con éxito',
  'is required': 'es obligatorio',
  'Current Limit (A)': 'Límite de corriente (A)',
  'Intervals cannot overlap and must be in chronological order':
    'Los intervalos no pueden superponerse y deben estar en orden cronológico',
  'Current Limit must be different from Default Limit':
    'El límite de corriente actual debe ser diferente del límite de corriente predeterminado',
  'Confirm exclusion': 'Confirmar exclusión',
  'When deleting the Pricing Profile': 'Al eliminar el Perfil de Precios',
  ', it will be unlinked from all chargers.':
    ', se desvinculará de todos los cargadores.',
  'Are you sure?': '¿Estás seguro?',
  No: 'No',
  Title: 'Título',
  'Failed to delete the Pricing Profile':
    'Error al eliminar el Perfil de Precios',
  'Error deleting the Pricing Profile:':
    'Error al eliminar el Perfil de Precios:',
  'Pricing Profile deleted successfully':
    'Perfil de Precios eliminado con éxito',
  '8 to 25 characters': '8 a 25 caracteres',
  'At least one uppercase letter': 'Al menos una letra mayúscula',
  'At least one lowercase letter': 'Al menos una letra minúscula',
  'At least one special character': 'Al menos un carácter especial',
  'At least one number': 'Al menos un número',
  'New vehicle': 'Vehículo Nuevo',
  Company: 'Empresa',
  'Creating company': 'Registro de empresa',
  'Sap Code': 'Código SAP',
  'Update Company': 'Actualizar Empresa',
  'Create Company': 'Crear Empresa',
  'Edit Company': 'Editar Empresa',
  'Failed to load the company!': '¡No fue posible cargar la empresa!',
  'Go back': 'Volver',
  'Try again': 'Intentar de nuevo',
  'Failed to update the company!': '¡Error al actualizar la empresa!',
  'Company updated successfully!': '¡Empresa actualizada con éxito!',
  'The license plate field is mandatory.':
    'El campo de la placa es obligatorio.',
  'The Company field is mandatory.': 'El campo empresa es obligatorio.',
  'Search by car license plate or company':
    'Buscar por matrícula del coche o empresa',
  'When deleting the Company': 'Al eliminar la empresa',
  'It will be unlinked from all users':
    ', será desvinculada de todos los usuarios.',
  'Company deleted successfully': 'Empresa eliminada con éxito',
  'Error deleting the Company': 'Error al eliminar la empresa',
  'No company': 'Sin empresa',
  'Failed to create company.': 'Error al crear la empresa',
  'The company name field is required.':
    'El campo nombre de la empresa es obligatorio.',
  'The NIT field is required.': 'El campo NIT es obligatorio.',
  'The Sap Code field is required.': 'El campo Sap Code es obligatorio.',
  'No results found': 'No se encontraron resultados',
  'Trusted user': 'Usuario confiable',
  'High risk': 'Riesgo alto',
  'Medium risk': 'Riesgo medio',
  'Low risk': 'Riesgo bajo',
  'No score': 'Sin puntuación',
  'Loading score': 'Cargando puntuación',
  'Card': 'Tarjeta',
  'No card': 'Sin tarjeta',
  'Score unavailable': 'Puntuación no disponible',
  'By selecting this option, the system will skip credit card authenticity verification for this user.':
    'Al seleccionar esta opción, el sistema omitirá la verificación de autenticidad de la tarjeta de crédito para este usuario.',
  'Mark as trusted user': 'Marcar como usuario confiable',
  'By marking this user as trusted, you will be assuming the risks of possible fraud associated with this account.':
    'Al marcar al usuario como confiable, asumirá los riesgos de posibles fraudes asociados a esta cuenta.',
  Vehicles: 'Vehículos',
  'Editing Vehicle': 'Editando vehículo',
  'Edit Vehicle': 'Editar vehículo',
  Block: 'Bloque',
  Apartment: 'Apartamento',
  'Report by apartment': 'Reporte por apartamento',
  'License code': 'Código de licencia',
  'The License Code field is mandatory.':
    'El campo Código de Licencia es requerido.',
  'The License Code is expired.': 'El Código de Licencia ha expirado.',
  'Duration (in minutes) after which the idle time pricing will be applied.':
    'Duración (en minutos) después de la cual se aplicará el precio del tiempo ocioso.',
  'Beneficiary Accounts': 'Cuentas beneficiarias',
  'Data and BI': 'Datos y BI',
  'Create Account': 'Crear una cuenta',
  'Provide a value for income': 'Proporcione un valor para ingresos',
  'Provide a valid CPF/CNPJ': 'Proporcione un CPF/CNPJ válido',
  'Provide a value for cost': 'Proporcione un valor para costos',
  'Client CPF/CNPJ': 'CPF/CNPJ del cliente',
  'Idle Charging Cost': 'Costo de Carga Inactiva',
  'Enable Idle Charging': 'Habilitar Carga Inactiva',
  'Need different values per connector?':
    '¿Necesita valores diferentes por conector?',
  'Configure individually': 'Configurar individualmente',
  'Get Composite Schedule': 'Obtener Cronograma Compuesto',
  '0 = charge point as a whole': '0 = cargador como un todo',
  '-- Empty --': '-- Vacío --',
  'Duration (in seconds)': 'Duración (en segundos)',
  'Schedule Start': 'Inicio del Cronograma',
  'Start Schedule': 'Inicio del Cronograma de Carga',
  'Min Charging Rate': 'Tasa Mínima de Carga',
  'Start Period (in sec)': 'Inicio del Período (en seg)',
  'Number Phases': 'Número de Fases',
  'Change statement value': 'Cambiar valor del extracto',
  'Add value': 'Agregar valor',
  'Remove value': 'Quitar valor',
  'Enter a value greater than zero': 'Ingrese un valor mayor que cero',
  'Operation type': 'Tipo de operación',
  'The value will be added to the balance': 'El valor será sumado al saldo',
  'The value will be subtracted from the balance':
    'El valor será restado del saldo',
  Confirm: 'Confirmar',
  'Ex: 10,00': 'Ej: 10,00',
  'Balance updated successfully': 'Saldo actualizado con éxito',
  'Failed to update balance': 'Error al actualizar el saldo',
  'Wallet changed for': 'Billetera modificada de',
  'Changed by': 'Modificado por',
  'Failed to load': 'Error al cargar',
  'Stop charging': 'Detener recarga',
  'Are you sure you want to force-stop the charging?\n\nBefore continuing, try using the "Stop charging" command in Operations. By forcing the stop, the charging will be finalized with the values measured so far.':
    '¿Está seguro de que desea forzar la finalización de la recarga?\n\nAntes de continuar, intente utilizar el comando "Detener recarga" en Operaciones. Al forzar la finalización, la recarga se finalizará con los valores medidos hasta el momento.',
  'Charging stopped successfully!': '¡Recarga detenida con éxito!',
  'Failed to stop charging.': 'Error al detener la recarga.',
  // Interoperability tour (MV2-1791)
  'See the tour again': 'Ver el tutorial de nuevo',
  'Back': 'Atrás',
  'Next step': 'Siguiente paso',
  'Got it': 'Entendido',
  'Skip tour': 'Saltar tutorial',
  'What this module does': 'Qué hace este módulo',
  'Interoperability lets two accounts share the visibility of their stations. The tabs follow the order of the process, left to right, and this tour walks through them in that order.': 'La Interoperabilidad permite que dos cuentas compartan la visualización de sus estaciones. Las pestañas siguen el orden del proceso, de izquierda a derecha, y este tutorial las recorre en ese orden.',
  'Eligibility is the gate': 'La elegibilidad es la puerta',
  'Nothing else works before this: the account and the sub-accounts you choose need to be eligible to bind. Turning it on opens data replication to the interoperability service, which is why it is behind its own permission.': 'Nada más funciona antes de esto: la cuenta y las subcuentas que elijas necesitan ser elegibles para vincularse. Activarlo abre la replicación de datos hacia el servicio de interoperabilidad, y por eso está detrás de un permiso propio.',
  'An accepted invite becomes a contract': 'Una invitación aceptada se convierte en contrato',
  'Here are the contracts already in force, with who and in which direction. Bidirectional means both sides see each other — it depends on the partner having an app of their own. One-way means only one side sees. The same contracts also show as a map of links.': 'Aquí están los contratos vigentes, con quién y en qué dirección. Bidireccional significa que ambos lados se ven — depende de que el socio tenga su propia aplicación. Unilateral significa que solo un lado ve. Los mismos contratos también aparecen como un mapa de vínculos.',
  'What the contract delivers': 'Lo que entrega el contrato',
  'The stations the contract made visible to you, and the ones you made visible to the partner. This is the tab that shows the result of everything above.': 'Las estaciones que el contrato hizo visibles para ti, y las que hiciste visibles para el socio. Es la pestaña que muestra el resultado de todo lo anterior.',
  'Charges across accounts': 'Recargas entre cuentas',
  'Charging sessions your drivers ran on partner stations, and the ones partner drivers ran on yours.': 'Las recargas que tus conductores hicieron en estaciones del socio, y las que los conductores del socio hicieron en las tuyas.',
  'Who changed what': 'Quién cambió qué',
  'Every change to eligibility, invites and contracts, with author and date. Use it to answer why a partner stopped seeing your stations.': 'Cada cambio de elegibilidad, invitaciones y contratos, con autor y fecha. Úsalo para responder por qué un socio dejó de ver tus estaciones.',
  'For whoever integrates a system': 'Para quien va a integrar un sistema',
  'Account settings, not day-to-day operation: the access key and the endpoint documentation, for reading this same data from outside the dashboard.': 'Configuración de la cuenta, no operación del día: la clave de acceso y la documentación de los endpoints, para leer estos mismos datos desde fuera del dashboard.',
  // Interoperability tour - fluxo de convite (MV2-1791)
  'Tutorial': 'Tutorial',
  'Invite and token flow': 'Flujo de invitación y token',
  'First, your account token': 'Primero, el token de tu cuenta',
  'This token is the address of your account: you hand it to a partner so they are able to invite you. It is not the invite itself — it can be shown again and renewed whenever you want, and whoever holds it can only invite you. Accepting is always your own act.': 'Este token es la dirección de tu cuenta: se lo entregas a un socio para que pueda invitarte. No es la invitación — puede volver a mostrarse y renovarse cuando quieras, y quien lo tenga solo puede invitarte. Aceptar es siempre un acto tuyo.',
  'Inviting starts with the partner token': 'Invitar empieza por el token del socio',
  'Ask the partner for the token on their own Interoperability screen, paste it here and check it. The check tells you whether that account has an app configured: with no app it does not display stations, so only the one-way contract is possible. Then you pick which of your accounts enter the contract and how long the invite stays valid.': 'Pide al socio el token que aparece en su propia pantalla de Interoperabilidad, pégalo aquí y verifícalo. La verificación indica si esa cuenta tiene aplicación configurada: sin aplicación no muestra estaciones, así que solo cabe el contrato unilateral. Después eliges cuáles de tus cuentas entran en el contrato y por cuánto tiempo vale la invitación.',
  'The invite token is a different one': 'El token de la invitación es otro',
  'Generating the invite produces a second token: single use, shown only once and kept only as a hash, so it cannot be recovered. Send it to the partner through a safe channel. On the receiving side it is pasted right here, in "Enter token", where the summary says how many accounts and stations the contract shares before it is authorized.': 'Generar la invitación produce un segundo token: de un solo uso, mostrado una única vez y guardado solo como hash, por lo que no puede recuperarse. Envíalo al socio por un canal seguro. Del lado de quien lo recibe se pega justo aquí, en "Ingresar token", donde el resumen indica cuántas cuentas y cuántas estaciones comparte el contrato antes de autorizarlo.',
  'A received invite waits here': 'La invitación recibida espera aquí',
  'When someone invites you, the notice shows up at the top of the screen with the time left, and "Review invite" opens the acceptance straight away — no need to hunt for the token in your e-mail.': 'Cuando alguien te invita, el aviso aparece en la parte superior de la pantalla con el tiempo restante, y "Revisar invitación" abre la aceptación de inmediato — sin tener que buscar el token en el correo.',
  'Every invite, in both directions': 'Todas las invitaciones, en los dos sentidos',
  'The ones you sent and the ones you received, with what became of each: pending, used, expired or revoked. A pending invite can still be revoked; an expired one cannot be reused, and connecting that partner takes a new invite.': 'Las que enviaste y las que recibiste, con lo que pasó con cada una: pendiente, usada, vencida o revocada. Una invitación pendiente todavía puede revocarse; una vencida no se reutiliza, y conectar a ese socio exige una invitación nueva.',
  'This module is not available for your account.': 'Este módulo no está disponible para tu cuenta.',
  'Your account does not have access to this area. Talk to the administrator if you need it.': 'Tu cuenta no tiene acceso a esta área. Habla con el administrador si lo necesitas.',
  'Back to home': 'Volver al inicio',
  'There is already an active invite for this partner. To generate a new one, revoke the previous one on the Invites tab.': 'Ya existe una invitación activa para este socio. Para generar una nueva, revoca la anterior en la pestaña Invitaciones.',
  'Do not charge idle time': 'No cobrar ociosidad',
  'Idle charging 24 hours': 'Cobrar ociosidad 24 horas',
  'Customize idle exemption per day': 'Personalizar exención por día',
  'Charge idle time all day': 'Cobrar ociosidad todo el día',
  'Idle exemption description': 'Configura los horarios en que no habrá cobranza de ociosidad cada día de la semana',
  'Idle exemption always charge empty state': 'Cobranza de ociosidad activa 24 horas, todos los días',
  'Idle exemption inactive empty state': 'Active "Personalizar por día" para configurar horarios diferentes cada día',
  'Idle exemption hint prefix': 'De las',
  'Idle exemption hint separator': 'a las',
  'Idle exemption hint suffix': 'la ociosidad no será cobrada',
  'Use custom idle exemption per connector': 'Usar horario propio (si no, hereda de la estación)',
  'Per-connector idle exemption overrides': 'Overrides de exención por conector',
  'Idle exemption periods overlap': 'Rangos se superponen en el mismo día',
  // MV2-1609 — agendamento de push (aba Agendados, bloco "Quando enviar" e modal de
  // edição). As chaves são o texto em português usado no codigo.
  'Agendados': 'Programados',
  'Agendar': 'Programar',
  'Agendar envio': 'Programar envío',
  'Agendamento atualizado com sucesso': 'Programación actualizada con éxito',
  'Agendamento cancelado': 'Programación cancelada',
  'Ações': 'Acciones',
  'A data-fim precisa ser depois do primeiro disparo':
    'La fecha final debe ser posterior al primer envío',
  'Cancelar': 'Cancelar',
  'Cancelar agendamento': 'Cancelar programación',
  'Cancelar agendamento?': '¿Cancelar programación?',
  'Data do disparo': 'Fecha del envío',
  'Data/hora': 'Fecha/hora',
  'Destinatários': 'Destinatarios',
  'Disparo imediato para os destinatários': 'Envío inmediato a los destinatarios',
  'Editar': 'Editar',
  'Editar agendamento': 'Editar programación',
  'Em meses que não têm o dia escolhido, o disparo cai no último dia do mês: 31/01 vira 28/02.':
    'En los meses que no tienen el día elegido, el envío cae en el último día del mes: 31/01 pasa a 28/02.',
  'Enviar agora': 'Enviar ahora',
  'Erro ao carregar agendamentos': 'Error al cargar las programaciones',
  'Escolha data e hora do disparo': 'Elija la fecha y la hora del envío',
  'Este agendamento já foi processado e não pode mais ser cancelado.':
    'Esta programación ya fue procesada y no se puede cancelar.',
  'Este agendamento já foi processado e não pode mais ser editado.':
    'Esta programación ya fue procesada y no se puede editar.',
  'Este agendamento não existe mais. Atualize a lista.':
    'Esta programación ya no existe. Actualice la lista.',
  'Fuso horário': 'Zona horaria',
  'Hora do disparo': 'Hora del envío',
  'Informe a data do disparo': 'Indique la fecha del envío',
  'Informe a hora do disparo': 'Indique la hora del envío',
  'Informe até quando repetir': 'Indique hasta cuándo repetir',
  'Mensagem': 'Mensaje',
  'Nenhum push agendado': 'Ningún push programado',
  'Não foi possível agendar o push. Tente novamente.':
    'No fue posible programar el push. Inténtelo de nuevo.',
  'Não foi possível cancelar o agendamento. Tente novamente.':
    'No fue posible cancelar la programación. Inténtelo de nuevo.',
  'Não foi possível salvar o agendamento. Tente novamente.':
    'No fue posible guardar la programación. Inténtelo de nuevo.',
  'Não foi possível salvar: verifique os campos preenchidos.':
    'No fue posible guardar: verifique los campos completados.',
  'Não repetir': 'No repetir',
  'O campo mensagem é obrigatório.': 'El campo mensaje es obligatorio.',
  'O campo título é obrigatório.': 'El campo título es obligatorio.',
  'O disparo precisa ser no futuro': 'El envío debe ser en el futuro',
  'O serviço de agendamento não está disponível no momento. Avise o suporte.':
    'El servicio de programación no está disponible en este momento. Avise a soporte.',
  'Por Região': 'Por Región',
  'Por Usuário': 'Por Usuario',
  'Push': 'Push',
  'Push agendado com sucesso': 'Push programado con éxito',
  'Push Notification em processamento. Acompanhe o resultado na aba Histórico.': 'La notificación push se está procesando. Siga el resultado en la pestaña Historial.',
  'Quando enviar': 'Cuándo enviar',
  'Repetir até': 'Repetir hasta',
  'Repetição': 'Repetición',
  'Se houver repetição,': 'Si hay repetición,',
  'Título': 'Título',
  'Toda semana': 'Cada semana',
  'Todo mês': 'Cada mes',
  'Todos': 'Todos',
  'Voltar': 'Volver',
  'até': 'hasta',
  'registros': 'registros',
  'serão canceladas. Essa ação não pode ser desfeita.':
    'serán canceladas. Esta acción no se puede deshacer.',
  'todas as ocorrências futuras': 'todas las ocurrencias futuras',
  'usuários': 'usuarios',
  'Audit Log': 'Registro de Auditoría',
  'Change history in the system': 'Historial de cambios realizados en el sistema',
  'Change type': 'Tipo de cambio',
  'What changed': 'Qué se cambió',
  'Where': 'Dónde se cambió',
  'Previous value': 'Valor anterior',
  'New value': 'Valor nuevo',
  'Date/Time': 'Fecha/Hora',
  'Changes in period': 'Cambios en el período',
  'Last change': 'Último cambio',
  'Audit records': 'Registros de auditoría',
  'All types': 'Todos los tipos',
  'Filter': 'Filtrar',
  'Clear': 'Limpiar',
  'Record details': 'Detalles del registro',
  'View details': 'Ver detalles',
  'Could not load the audit records': 'No se pudieron cargar los registros de auditoría',
  'Could not load the change types': 'No se pudieron cargar los tipos de cambio',
  'User document': 'Documento del usuario',
  'Wallet balance': 'Saldo de la billetera',
  'Manual charge stop': 'Parada manual de carga',
  'Charger type': 'Tipo del cargador',
  'Charger firmware': 'Firmware del cargador',
  'Station edit': 'Edición de estación',
  'Price profile edit': 'Edición de perfil de precio',
  'Advanced configuration edit': 'Edición de configuración avanzada',
  'Connector door opening': 'Apertura de puerta del conector',
  'Access door': 'Puerta de acceso',
  Connector: 'Conector',
  'Door disabled': 'Desactivado',
  'Door not configured': 'Sin configuración',
  Configured: 'Configurado',
  'Each connector has its own door.': 'Cada conector tiene su propia puerta.',
  'Could not load the door settings.': 'No fue posible cargar la configuración de la puerta.',
  'Discard changes?': '¿Descartar cambios?',
  'The changes to this connector have not been saved.': 'Los cambios de este conector no se han guardado.',
  Discard: 'Descartar',
  'This connector has door unlock': 'Este conector tiene desbloqueo de puerta',
  'When enabled, enables remote opening settings and the unlock button in the driver app': 'Cuando está activado, habilita la configuración de apertura remota y el botón de desbloqueo en la app del conductor',
  'How it opens': 'Cómo abre',
  'Opening method': 'Método de apertura',
  'HTTP call (webhook)': 'Llamada HTTP (webhook)',
  'Opening is always triggered by someone, from the button in the app or from the dashboard, never by a reader on the equipment.': 'La apertura siempre la dispara alguien, desde el botón en la app o desde el dashboard, nunca un lector en el equipo.',
  'HTTP call': 'Llamada HTTP',
  Timeout: 'Tiempo de espera',
  '{0} s (system default)': '{0} s (predeterminado del sistema)',
  'Test connection': 'Probar conexión',
  'Open door now': 'Abrir puerta ahora',
  'Save your changes before opening the door.': 'Guarde los cambios antes de abrir la puerta.',
  'Last opening': 'Última apertura',
  'No opening recorded.': 'Ninguna apertura registrada.',
  'Last 10 openings': 'Últimas 10 aperturas',
  View: 'Ver',
  Close: 'Cerrar',
  'Could not load the opening history.': 'No fue posible cargar el historial de aperturas.',
  'Driver app': 'App del conductor',
  Dashboard: 'Dashboard',
  'Door settings saved.': 'Configuración de la puerta guardada.',
  'Check the highlighted fields.': 'Verifique los campos resaltados.',
  'Open the door now?': '¿Abrir la puerta ahora?',
  'This will unlock the access door of this connector.': 'Esto desbloqueará la puerta de acceso de este conector.',
  'Open door': 'Abrir puerta',
  'Unsaved changes do not apply to this opening.': 'Los cambios no guardados no se aplican a esta apertura.',
  'The settings on screen will be used for this opening, without saving.': 'La apertura usa la configuración de la pantalla, sin guardar.',
  'The access door of connector {0} was not saved: {1}': 'La puerta de acceso del conector {0} no se guardó: {1}',
  'Copy from connector {0}': 'Copiar del conector {0}',
  'No attempt in this session': 'Ningún intento en esta sesión',
  'Request failed': 'Falla en la solicitud',
  'Timed out': 'Tiempo agotado',
  'Network error': 'Error de red',
  'Enter the controller URL': 'Ingrese la URL del controlador',
  Headers: 'Encabezados',
  Key: 'Clave',
  'Description (optional)': 'Descripción (opcional)',
  'JSON body': 'Cuerpo del mensaje',
  'Enter the request body in JSON': 'Ingrese el cuerpo de la solicitud en JSON',
  'Variables:': 'Variables:',
  'The URL field is mandatory.': 'El campo URL es obligatorio.',
  'The URL must start with http:// or https://.': 'La URL debe comenzar con http:// o https://.',
  'The body is not valid JSON.': 'El cuerpo no es un JSON válido.',
  'The header key is mandatory.': 'La clave del encabezado es obligatoria.',
  'The header value is mandatory.': 'El valor del encabezado es obligatorio.',
  'HTTP method': 'Método HTTP',
  'Controller URL': 'URL del controlador',
  'Door settings saved, but the status could not be refreshed.': 'Configuración de la puerta guardada, pero no fue posible actualizar el estado.',
  'The door was triggered, but the last opening could not be refreshed.': 'La puerta fue accionada, pero no fue posible actualizar la última apertura.',
  'Unexpected code {0}': 'Código inesperado {0}',
  'Test sent: {0}': 'Prueba enviada: {0}',
  'Door opened: {0}': 'Puerta abierta: {0}',
  'Test failed: {0}': 'La prueba falló: {0}',
  'Opening failed: {0}': 'Falla al abrir: {0}',
  'Connection checked in {0} ms.': 'Conexión verificada en {0} ms.',
  'Synchronous call completed in {0} ms.': 'Disparo síncrono completado en {0} ms.',
  'Remove header': 'Eliminar encabezado',
  Save: 'Guardar',
  'Door enabled': 'Activado',
  'Door unlock is not configured for this connector': 'Desbloqueo de puerta no configurado para este conector.',
  'URL is required': 'La URL es obligatoria.',
  'URL must start with http:// or https://': 'La URL debe comenzar con http:// o https://.',
  'Body is not a valid JSON': 'El cuerpo no es un JSON válido.',
  'Header key is required': 'La clave del encabezado es obligatoria.',
  'Header value is required': 'El valor del encabezado es obligatorio.',
  'Header key has invalid characters': 'La clave del encabezado tiene caracteres inválidos.',
  'Header value has invalid characters': 'El valor del encabezado tiene caracteres inválidos.',
  'Charge point not found': 'Estación no encontrada.',
  'Connector not found': 'Conector no encontrado.',
  'Invalid URL': 'URL inválida.',
  'Invalid header': 'Encabezado inválido.',
  'Destination not allowed': 'Destino no permitido.',
  'Call interrupted': 'Llamada interrumpida.',
  'The controller did not respond in time': 'El controlador no respondió a tiempo.',
  'Device ID': 'Device ID',
  'Enter the controller DEVICE_ID': 'Ingrese el DEVICE_ID del controlador',
  'The Device ID field is mandatory.': 'El campo Device ID es obligatorio.',
  "The Device ID may only have letters, digits, '_' and '-'.": "El Device ID solo puede tener letras, números, '_' y '-'.",
  'The body is mandatory.': 'El cuerpo es obligatorio.',
  'Unexpected response': 'Respuesta inesperada',
  'Device ID is required': 'El Device ID es obligatorio.',
  "Device ID may only have letters, digits, '_' and '-'": "El Device ID solo puede tener letras, números, '_' y '-'.",
  'Body is required': 'El cuerpo es obligatorio.',
  'RabbitMQ is disabled on this server': 'RabbitMQ está desactivado en este servidor.',
  'Could not reach the message broker': 'No fue posible conectar con RabbitMQ.',
  'Could not connect to the controller': 'No fue posible conectar con el controlador.',
  'Too many door calls at the same time, try again in a moment': 'Demasiadas llamadas al mismo tiempo. Intente nuevamente en unos instantes.',
  'A door opening is already in progress for this connector': 'Ya hay una apertura en curso en este conector.',
  // MV2-1974 módulo OCPI
  'All': 'Todas',
  'All charges made at the stations published via OCPI, by partner users or not. The partner of each charge is not identified.': 'Todas las cargas realizadas en las estaciones publicadas vía OCPI, de usuarios de socios o no. No se identifica el socio de cada carga.',
  'All states': 'Todas las regiones',
  'All statuses': 'Todos los estados',
  'Amount': 'Valor',
  'Average duration': 'Duración media',
  'Back': 'Volver',
  'Billed in the period': 'Facturado en el período',
  'Blocked': 'Bloqueada',
  'CDR': 'CDR',
  'CDR available': 'CDR disponible',
  'CDR of charge': 'CDR de la carga',
  'CDRs in the period': 'CDRs en el período',
  'Charge': 'Carga',
  'Charge data': 'Datos de la carga',
  'Charges': 'Cargas',
  'Charges at this station in the period': 'Cargas en esta estación en el período',
  'Charges in progress': 'Cargas en curso',
  'Check whether the partner has already sent the token.': 'Verifique si el socio ya envió el token.',
  'Completed': 'Concluida',
  'Connector': 'Conector',
  'Connector status now': 'Estado de los conectores ahora',
  'Coordinates': 'Coordenadas',
  'Could not load the OCPI data. Try again in a few minutes.': 'No fue posible cargar los datos OCPI. Intente de nuevo en unos minutos.',
  'Could not look up the token. Try again in a few minutes.': 'No fue posible consultar el token. Intente de nuevo en unos minutos.',
  'Currency': 'Moneda',
  'E.g.: 04A2B7719C81': 'Ej.: 04A2B7719C81',
  'Ended': 'Finalizada',
  'Ended without consumption': 'Finalizada sin consumo',
  'Energy in the period': 'Energía en el período',
  'Enter the UID of the token the partner sent to see the linked tag in the CS.': 'Ingrese el UID del token que envió el socio para ver la tag vinculada en el CS.',
  'Error reported by the station': 'Error informado por la estación',
  'Generated when it ends': 'Se genera al finalizar',
  'Idle fee': 'Tarifa por inactividad',
  'In OCPI, each connector is published as an EVSE.': 'En OCPI, cada conector se publica como un EVSE.',
  'In progress': 'En curso',
  'Inoperative': 'Inoperante',
  'Invalid': 'Inválida',
  'Invalid charges do not generate a CDR': 'Una carga inválida no genera CDR',
  'Last 30 days': 'Últimos 30 días',
  'Last 7 days': 'Últimos 7 días',
  'List': 'Lista',
  'Location': 'Ubicación',
  'Location (address_pk)': 'Ubicación (address_pk)',
  'Look up': 'Consultar',
  'Look up OCPI token': 'Consultar token OCPI',
  'Look up token': 'Consultar token',
  'Map': 'Mapa',
  'No CDR': 'Sin CDR',
  'No CDRs in the period.': 'No hay CDRs en el período.',
  'No OCPI token with the UID': 'Ningún token OCPI con el UID',
  'No charges at this station in the period.': 'No hay cargas en esta estación en el período.',
  'No charges in the period.': 'No hay cargas en el período.',
  'No fee': 'Sin tarifa',
  'No photos': 'Sin fotos',
  'No station is marked as OCPI compatible in this account yet.': 'Ninguna estación de esta cuenta está marcada como compatible con OCPI.',
  'No station with these filters.': 'Ninguna estación con estos filtros.',
  'OCPI UID': 'UID OCPI',
  'Out of order': 'Fuera de servicio',
  'Overview': 'Resumen',
  'Pending': 'Pendiente',
  'Per kWh': 'Por kWh',
  'Per minute': 'Por minuto',
  'Period (start date)': 'Período (fecha de inicio)',
  'Planned': 'Planificada',
  'Published stations': 'Estaciones publicadas',
  'Recent charges': 'Cargas recientes',
  'Registered on': 'Registrada el',
  'Removed': 'Eliminada',
  'Reservation': 'Reserva',
  'Showing the first': 'Mostrando las primeras',
  'Start': 'Inicio',
  'Start → end': 'Inicio → fin',
  'Started': 'Iniciada',
  'Station ID, UUID, address or city': 'ID de la estación, UUID, dirección o ciudad',
  'Stations published via OCPI and the charges made on them.': 'Estaciones publicadas vía OCPI y las cargas realizadas en ellas.',
  'Stations with the most energy in the period': 'Estaciones con más energía en el período',
  'Status': 'Estado',
  'Suspended by station': 'Suspendido por la estación',
  'Suspended by vehicle': 'Suspendido por el vehículo',
  'Tag': 'Tag',
  'Tag in the CS': 'Tag en el CS',
  'Timeline': 'Línea de tiempo',
  'Today': 'Hoy',
  'Token UID': 'UID del token',
  'Total': 'Total',
  'Unknown': 'Desconocido',
  'Updated on': 'Actualizado el',
  'View CDR': 'Ver CDR',
  'View charge': 'Ver carga',
  'View station': 'Ver estación',
  'Waiting to start': 'Esperando inicio',
  'charges': 'cargas',
  'connectors': 'conectores',
  'ongoing': 'en curso',
  'Connector faulted': 'Con falla',
  'Connector finishing': 'Finalizando',
  'Connector unavailable': 'No disponible',
  'Charge period': 'Período',
  'since': 'desde',
  'started in the period': 'iniciadas en el período',
  'stations': 'estaciones',
  'up to': 'hasta',
  'with a faulted or unavailable connector': 'con conector con falla o no disponible',
  // MV2-1974 módulo OCPI: recebidas como parceiro
  'Received as partner': 'Recibidas como socio',
  'Could not load the stations received as a partner.': 'No fue posible cargar las estaciones recibidas como socio.',
  'This account has no external id in the cross, so it does not receive stations as a partner.': 'Esta cuenta no tiene external id en el cross, por lo que no recibe estaciones como socio.',
  'Stations this account receives as a partner (eMSP) through the bindings in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Estaciones que esta cuenta recibe como socio (eMSP) por los vínculos en el cross. Es la misma lista que el servicio OCPI usa para armar el /locations del socio.',
  'Account in the cross': 'Cuenta en el cross',
  'external id': 'external id',
  'Stations received': 'Estaciones recibidas',
  'operators': 'operadores',
  'Go into the feed': 'Entran en el feed',
  'with address, coordinates and operator': 'con dirección, coordenadas y operador',
  'Discarded by the OCPI': 'Descartadas por el OCPI',
  'never reach the partner': 'nunca llegan al socio',
  'The cross returned more pages than the dashboard reads. Only the first ones are shown.': 'El cross devolvió más páginas de las que lee el dashboard. Solo se muestran las primeras.',
  'No station is bound to this account as a partner.': 'Ninguna estación está vinculada a esta cuenta como socio.',
  'By operator': 'Por operador',
  'Operator': 'Operador',
  'Feed': 'Feed',
  'Discarded': 'Descartada',
  'Goes into the feed': 'Entra en el feed',
  'No operator name': 'Sin nombre del operador',
  'No address': 'Sin dirección',
  'No coordinates': 'Sin coordenadas',
  'Click an operator to see only its stations.': 'Haga clic en un operador para ver solo sus estaciones.',
  'Search operator': 'Buscar operador',
  'No operator with this name.': 'Ningún operador con ese nombre.',
  'Station code, description, address or city': 'Código, descripción, dirección o ciudad de la estación',
  'All operators': 'Todos los operadores',
  'Stations this account sends and receives via OCPI, and the charges made on the ones it sends.': 'Estaciones que esta cuenta envía y recibe vía OCPI, y las cargas realizadas en las que envía.',
  'Sent stations': 'Estaciones enviadas',
  'Received stations': 'Estaciones recibidas',
  'This account does not receive stations as a partner.': 'Esta cuenta no recibe estaciones como socio.',
  'go into the feed': 'entran en el feed',
  'discarded': 'descartadas',
  'Sending': 'Enviando',
  'Stations of this account that the partners see': 'Estaciones de esta cuenta que ven los socios',
  'with a faulted connector': 'con conector con falla',
  'View sent stations': 'Ver estaciones enviadas',
  'Receiving': 'Recibiendo',
  'Stations of other operators bound to this account in the cross': 'Estaciones de otros operadores vinculadas a esta cuenta en el cross',
  'View received stations': 'Ver estaciones recibidas',
  'Charges at the stations this account sends': 'Cargas en las estaciones que envía esta cuenta',
  'Receiving as partner (eMSP)': 'Recibiendo como socio (eMSP)',
  'Stations of other operators bound to this account in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Estaciones de otros operadores vinculadas a esta cuenta en el cross. Es la misma lista que el servicio OCPI usa para armar el /locations del socio.',
  'Green goes into the feed, red is discarded by the OCPI. Stations without coordinates do not appear on the map.': 'Verde entra en el feed, rojo lo descarta el OCPI. Las estaciones sin coordenadas no aparecen en el mapa.',
  'Sending as operator (CPO)': 'Enviando como operador (CPO)',
  'Stations of this account that the OCPI service publishes to the partners: public and marked as OCPI compatible.': 'Estaciones de esta cuenta que el servicio OCPI publica para los socios: públicas y marcadas como compatibles con OCPI.',
  'Why the OCPI discards it': 'Por qué el OCPI la descarta',
  'Open in Google Maps': 'Abrir en Google Maps',
  'Close': 'Cerrar',
  'Online': 'En línea',
  'Offline': 'Fuera de línea',
  'Reason': 'Motivo',
  'The OCPI service leaves this station out of the partner /locations until the data is fixed in the operator account.': 'El servicio OCPI deja esta estación fuera del /locations del socio hasta que se corrija el dato en la cuenta del operador.',
  'The partner receives this station in /locations. In OCPI, each connector is published as an EVSE.': 'El socio recibe esta estación en /locations. En OCPI, cada conector se publica como un EVSE.',
  'Connection': 'Conexión',
  'No connector registered.': 'Ningún conector registrado.',
  'The partners receive this station in /locations. In OCPI, each connector is published as an EVSE.': 'Los socios reciben esta estación en /locations. En OCPI, cada conector se publica como un EVSE.',
  'ZIP code': 'Código postal',
  'Since': 'Desde',
  'Showing only': 'Mostrando solo',
  'Minimized. Expand to filter by operator.': 'Minimizado. Expanda para filtrar por operador.',
  'Expand': 'Expandir',
  'Minimize': 'Minimizar',
  'Sending and receiving': 'Enviando y recibiendo',
  Tickets: 'Tickets',
  'Tickets (Internal)': 'Tickets (Interno)',
  'You do not have access to this area': 'No tienes acceso a esta área',
  'Open ticket': 'Abrir ticket',
  'Open tickets': 'Abiertos',
  'Resolved tickets': 'Resueltos',
  'Filter by company': 'Filtrar por empresa',
  'Tickets are not configured for your company yet': 'Los tickets aún no están configurados para tu empresa',
  'Could not load tickets': 'No se pudieron cargar los tickets',
  'No tickets yet': 'Aún no hay tickets',
  'Medium priority': 'Media',
  'Load more': 'Cargar más',
  'File type not allowed': 'Tipo de archivo no permitido',
  'File too large (max 10 MB)': 'Archivo demasiado grande (máx. 10 MB)',
  'Ticket created': 'Ticket creado',
  'Ticket review step': 'Revisión',
  'Choose a request type': 'Elija un tipo de solicitud',
  'Which company is this ticket about?': '¿Sobre qué empresa es este ticket?',
  'My own company (default)': 'Mi propia empresa (predeterminado)',
  'Could not load request types': 'No se pudieron cargar los tipos de solicitud',
  'Could not load form fields': 'No se pudieron cargar los campos del formulario',
  'Upload failed': 'Error al subir el archivo',
  'Could not create the ticket': 'No se pudo crear el ticket',
  'Remove': 'Quitar',
  'Uploading': 'Subiendo',
  'Messages': 'Mensajes',
  'Write a reply': 'Escribe una respuesta',
  'Could not load the ticket': 'No se pudo cargar el ticket',
  'Could not send the message': 'No se pudo enviar el mensaje',
  'Ticket management — Move internal': 'Gestión de tickets — Move interno',
  'SLA at risk': 'SLA en riesgo',
  'Resolved today': 'Resueltos hoy',
  'Most frequent types': 'Tipos más frecuentes',
  'Tickets by company': 'Tickets por empresa',
  'Monthly volume': 'Volumen mensual',
  'Priority': 'Prioridad',
  'Assignee': 'Responsable',
  'Refresh types': 'Actualizar tipos',
  'Ticket': 'Ticket',
  'Internal note': 'Nota interna',
  'Agent account id': 'ID de cuenta del agente',
  'Assign': 'Asignar',
  'Invalid agent account id': 'ID de cuenta del agente inválido',
  'Could not change the status': 'No se pudo cambiar el estado',
  'Could not assign the ticket': 'No se pudo asignar el ticket',
  'Only visible to Move': 'Visible solo para Move',
  'Totals are global and not affected by the filters': 'Los totales son globales y no se ven afectados por los filtros',
  'No data': 'Sin datos',
  'Could not refresh the types': 'No se pudieron actualizar los tipos',
  'Critical priority': 'Crítica',
  'High priority': 'Alta',
  'Low priority': 'Baja',
  'Based on the loaded list': 'Basado en la lista cargada',
  'Opened on behalf of': 'Abierto en nombre de',
  'Could not load the status changes': 'No fue posible cargar los cambios de estado',
  'Reply to customer': 'Responder al cliente',
  'Internal note (only visible to Move)': 'Nota interna (visible solo para Move)',
  'The ticket may have been created but could not be linked to your company. Do not try again; contact support.': 'Es posible que el ticket se haya creado, pero no fue posible vincularlo a su empresa. No lo intente de nuevo; contacte al soporte.',
  // MV2-1952
  'Enter a valid e-mail, for example name@email.com':
    'Ingrese un correo electrónico válido, por ejemplo nombre@email.com',
};

export default locale;
